webpackJsonp([4],{

/***/ 1:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SEARCH_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USER_INFO; });

var SEARCH_HISTORY = 'SEARCH_HISTORY';
var USER_INFO = 'USER_INFO';

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(105)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(111),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fetch_jsonp__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fetch_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_fetch_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);





var A_MINUTE = 60000;
var AN_HOUR = 3600000;
var A_DAY = 86400000;

var Apm = function Apm(opts) {
    var _ts = this,
        defOpts = {};
    this.opts = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(defOpts, opts);

    this.config = {
        platform: navigator.userAgent.toLowerCase().match(/iphone|ipod|ipad/ig) ? 'ios' : 'android',
        app: {
            isInApp: _ts.app.isInApp || false,
            o: _ts.app.os || null,
            s: _ts.app.set || null,
            p: _ts.app.product || null,
            v: _ts.app.version || null }
    };
    this.tools = {
        getUrlName: function getUrlName(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.search.substr(1).match(reg);
            if (r !== null) return unescape(r[2]);
            return null;
        },
        loadJS: function loadJS(url, success) {
            var domScript = document.createElement('script');
            domScript.src = url;
            success = success || function () {};
            if (navigator.userAgent.indexOf("MSIE") > 0) {
                domScript.onreadystatechange = function () {
                    if ('loaded' === this.readyState || 'complete' === this.readyState) {
                        success();
                        this.onload = this.onreadystatechange = null;
                        this.parentNode.removeChild(this);
                    }
                };
            } else {
                domScript.onload = function () {
                    success();
                    this.onload = this.onreadystatechange = null;
                    this.parentNode.removeChild(this);
                };
            }
            document.getElementsByTagName('head')[0].appendChild(domScript);
        },

        returnData: function returnData(data, keyArr) {
            if ((typeof keyArr === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(keyArr)) === "object") {
                try {
                    return eval("data" + "." + keyArr.join("."));
                } catch (e) {
                    return "";
                }
            } else {
                try {
                    return data;
                } catch (e) {
                    return "";
                }
            }
        },

        zkopen_web: function zkopen_web(url, needUserInfo, openType) {
            if (!url) return false;
            needUserInfo = needUserInfo == 'Y' ? 'Y' : 'N';
            var cmd = {
                open_type: openType,
                web_url: url,
                need_user_info: needUserInfo
            };
            var cmdStr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(cmd);
            var cmdEncodeStr = encodeURIComponent(cmdStr);
            return 'zkopenthirdapp://?_zkcmd=open_type&iphone_cmd_arg=' + cmdEncodeStr + '&androidphone_cmd_arg=' + cmdEncodeStr;
        }
    };
    this.init();
};

Apm.prototype.install = function (Vue) {
    Vue.prototype.$apm = this;
    Vue.apm = this;
};

Apm.prototype.init = function () {
    var _ts = this;

    window.WinObserver = {
        add: function add(callback, opt) {
            this.subscribers[this.subscribers.length] = {
                callback: callback,
                opt: opt !== 'undefined' ? opt : {}
            };
        },

        remove: function remove(callback) {
            for (var i = 0; i < this.subscribers.length; i++) {
                if (this.subscribers[i].callback === callback) {
                    delete this.subscribers[i];
                }
            }
        },

        publish: function publish(what, _observer) {
            var data = {};
            for (var i = 0; i < this.subscribers.length; i++) {
                if (this.subscribers[i] && typeof this.subscribers[i].callback === 'function') {
                    var observer = _observer !== 'undefined' ? _observer : {};
                    var key = observer.type + '_' + what.type;

                    data[key] = this.subscribers[i].callback({ param: what, opt: this.subscribers[i].opt, observer: observer });
                }
            }
            return data;
        },

        make: function make(o) {
            for (var i in this) {
                o[i] = this[i];
                o.subscribers = [];
            }
        }
    };

    window.WinSubscribe = {
        WINBDClient: function WINBDClient(data) {
            return this.publish(data, { type: 'WINBDClient' });
        }
    };

    window.WinObserver.make(window.WinSubscribe);

    window.WINBDClient = function (param) {
        var data = window.WinSubscribe.WINBDClient(param);
        var key = 'WINBDClient_' + param.type;
        var _data = data[key] ? data[key] : { stat: 0, data: {} };
        return _data;
    };
};

Apm.prototype.app = function () {
    var ua = navigator.userAgent,
        opt = {};
    var reg = ua.match(/aipai\/(.*)\/(.*)\/(.*)\/v\((.*)\)/);
    if (reg) {
        opt.isInApp = reg[0];
        opt.os = reg[1];
        opt.set = reg[2];
        opt.product = reg[3];
        opt.version = reg[4];
    } else {
        opt.isInApp = false;
    }

    opt.is = function (arg) {
        if (reg) {
            return (typeof arg.o !== 'undefined' ? arg.o === opt.os : true) && (typeof arg.p !== 'undefined' ? arg.p === opt.product : true) && (typeof arg.s !== 'undefined' ? arg.s === opt.set : true) && (typeof arg.v !== 'undefined' ? opt.version >= arg.v : true);
        } else {
            return false;
        }
    };
    return opt;
}();

Apm.prototype.globalEvent = {
    handlerTraker: {},

    add: function add(evt, callback) {
        var _ts = this;
        if (!callback) {
            {
                console.error("[vue-render] missing callback arg in globalEvent.addEventListener.");
            }
            return;
        }
        var handlers = _ts.handlerTraker[evt];
        if (!handlers) {
            handlers = _ts.handlerTraker[evt] = [];
        }
        var len = handlers.length;
        for (var i = 0; i < len; i++) {
            if (handlers[i] === callback) {
                return;
            }
        }
        handlers.push(callback);
        document.addEventListener(evt, callback);
    },

    remove: function remove(evt) {
        var _ts = this,
            handlers = _ts.handlerTraker[evt];
        if (!handlers) {
            return;
        }
        handlers.forEach(function (cb) {
            return document.removeEventListener(evt, cb);
        });
        delete _ts.handlerTraker[evt];
    }
};

Apm.prototype.appClient = function (param) {
    try {
        var reg = new RegExp(__WEBPACK_IMPORTED_MODULE_3_config__["APP_UA"], 'ig');
        if (navigator.userAgent.match(reg)) {
            var _param = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, {
                type: '',
                data: {}
            }, param);
            if (typeof _param.data.cbParam == 'undefined') {
                _param.data.cbParam = {};
            }
            if (typeof _param.data.cbName == 'undefined') {
                _param.data.cbName = '';
            }
            _param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_param);
            var data = null;
            console.log(_param);
            if (!navigator.userAgent.match(/iphone|ipod/ig)) {
                data = window.BDClient.call(_param);
            } else {
                data = window.prompt(_param);
            }
            var _data = typeof data == 'string' ? JSON.parse(data) : data;
            return _data;
        } else {
            return {
                stat: 0,
                msg: '不在客户端内'
            };
        }
    } catch (err) {
        return {
            stat: 0,
            msg: '协议执行失败'
        };
    }
};

Apm.prototype.getHasFlagData = function (sign_arg, data) {
    if (!sign_arg) {
        return data;
    }
    var _time = String(Date.parse(new Date()) / 1000),
        sign_args = sign_arg.split('|'),
        prefix = sign_args[0],
        sign_argStr = sign_args[1],
        sign_argArr = sign_argStr.split(','),
        baseParams = this.getBaseParams(),
        allParams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(baseParams, data, { _time: _time }),
        _flag = __WEBPACK_IMPORTED_MODULE_3_config__["APP_KEY"] + prefix;
    sign_argArr.map(function (key) {
        _flag += allParams[key];
    });
    _flag += allParams['_time'];

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data, {
        _flag: this.md5(this.md5(_flag).toLowerCase()).toLowerCase(),
        _time: allParams['_time']
    });
};

Apm.prototype.getBaseParams = function () {
    var reg = new RegExp(__WEBPACK_IMPORTED_MODULE_3_config__["APP_UA"], 'ig');
    var baseParams = {
        _app_id: '',
        _version: '',
        _v: '',
        _brand: '',
        _systype: navigator.userAgent.match(/iphone|ipod/ig) ? 'iphone' : 'androidphone',
        _platform: '',
        _udid: '',
        _uid: '',
        _utoken: '',
        _uauthCode: ''
    };
    var pageData = {};
    var cbData = this.appClient({
        type: 'getBaseInfo',
        data: {}
    });
    if (cbData.stat == 1) {
        pageData = cbData.data;
    }
    if (!pageData._uid) {
        var paramArr = window.location.search.substr(1).split('&');
        for (var i = 0; i < paramArr.length; i++) {
            if (paramArr[i].match(/(.+?)=(.+?)/ig)) {
                var curArr = paramArr[i].split('=');
                pageData[curArr[0]] = decodeURIComponent(curArr[1]);
            }
        }
    }


    baseParams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(baseParams, {
        _app_id: pageData._app_id || '',
        _version: pageData._version || '',
        _v: pageData._v || '',
        _systype: pageData._systype || '',
        _brand: pageData._brand || '',
        _udid: pageData._udid || '',
        _uid: pageData._uid || '',
        _utoken: pageData._utoken || '',
        _platform: pageData._platform || ''
    });
    return baseParams;
};

Apm.prototype.appIsBridge = function (type) {};

Apm.prototype.appBridge = function (type, _data) {
    var data = _data || null,
        iframe = document.createElement('IFRAME');
    iframe.setAttribute('src', 'lieyou-vw://' + type + '/' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)));
    document.documentElement.appendChild(iframe);
    iframe.parentNode.removeChild(iframe);
    iframe = null;
};

Apm.prototype.refresh = function (type) {};

Apm.prototype.pageData = function () {
    var pageData = {};
    var paramArr = window.location.search.substr(1).split('&');
    for (var i = 0; i < paramArr.length; i++) {
        if (paramArr[i].match(/(.+?)=(.+?)/ig)) {
            var curArr = paramArr[i].split('=');
            pageData[curArr[0]] = decodeURIComponent(curArr[1]);
        }
    }
    return pageData;
}();

Apm.prototype.appStart = function (data) {};

Apm.prototype.wxShare = function (opt) {
    var shareTitle = opt.title || document.title;
    var shareDesc = opt.desc || '';
    var shareLink = opt.link || location.href;
    var sharePic = opt.imgUrl || 'https://zkres.myzaker.com/data/ads_web/share_pic.png';
    var shareTimelineDesc = opt.lineDesc || opt.desc || '';
    window.zk_get_share_info = function () {
        var zk_web_wxshare_param = {
            shareTitle: shareTitle,
            shareDesc: shareDesc,
            shareLink: shareLink,
            sharePic: sharePic,
            shareTimelineDesc: shareTimelineDesc
        };
        var arr = {
            type: "zk_web_wxshare_param",
            result: zk_web_wxshare_param
        };
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arr);
    };

    var sharesuccessFunc = function sharesuccessFunc() {
        if (opt.sucFun && typeof opt.sucFun == 'function') {
            opt.sucFun();
        }
    };
    var sharecancelFunc = function sharecancelFunc() {};
    var scriptdom = document.createElement("script");
    scriptdom.type = "text/javascript";
    scriptdom.src = "https://huodong.myzaker.com/wx/wechat_js_api_new.php?v=1";
    document.body.appendChild(scriptdom);
    scriptdom.onload = function () {
        wxShareNew.init(shareTitle, shareDesc, shareTimelineDesc, shareLink, sharePic, sharesuccessFunc, sharecancelFunc);
    };
};

Apm.prototype.initScrollTop = function () {
    var st = null,
        _scTop = document.createElement('span');
    _scTop.setAttribute('class', 'g_scrollTop hidden');
    _scTop.setAttribute('id', 'g_scrollTop');

    document.body.appendChild(_scTop);
    var _el = document.getElementById('g_scrollTop');
    window.addEventListener('scroll', function (event) {
        clearTimeout(st);
        st = setTimeout(function () {
            if (document.body.scrollTop > window.innerHeight) {
                _el.style.display = 'block';
                _el.addEventListener('click', function (event) {
                    _el.style.display = 'none';
                    event.preventDefault();
                    window.scrollTo(0, 0);
                });
            } else {
                _el.style.display = 'none';
            }
        }, 50);
    });
    _el.addEventListener('touchstart', function (event) {
        _el.classList.add('cur');
    });
    _el.addEventListener('touchend', function (event) {
        _el.classList.remove('cur');
    });
};

Apm.prototype.fetch = function (_opt) {
    var _ts = this,
        pageData = _ts.pageData,
        param = "",
        opt = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({
        method: "GET",
        type: "json",
        cookies: true,
        timeout: 10000,
        param: null,
        paramType: 0,
        headers: {},
        base: true
    }, _opt);
    var baseParams = this.getBaseParams();
    if (opt.base) {
        opt.param = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, baseParams, opt.param);
    }

    opt.param = this.getHasFlagData(opt.sign_arg, opt.param);

    if (baseParams._uauthCode) {
        opt.headers = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, { 'Authorization': __WEBPACK_IMPORTED_MODULE_3_config__["APP_AKEY"] + ' ' + baseParams._uauthCode }, opt.headers);
    }

    console.log('opt.param', opt.param);

    opt.url = opt.url.indexOf('http') >= 0 ? '' + opt.url : '' + __WEBPACK_IMPORTED_MODULE_3_config__["API_URL"] + opt.url;


    if (location.protocol === 'https:') {
        opt.url = opt.url.replace(/^http:(\/\/)/, "$1");
    }
    if (location.protocol === 'http:') {
        opt.url = opt.url.replace(/^https:(\/\/)/, "$1");
    }
    if (opt.param !== null) {
        for (var key in opt.param) {
            if (typeof opt.param[key] !== 'function') {
                param += '&' + key + '=' + encodeURIComponent(opt.param[key]);
            }
        }
        param = param.substring(1);
    }
    if (opt.method.toLowerCase() === "get") {
        if (opt.type === 'jsonp') {
            return __WEBPACK_IMPORTED_MODULE_5_fetch_jsonp___default()(opt.url + (opt.url.indexOf('?') >= 0 ? '&' : '?') + param, {
                timeout: opt.timeout,
                method: opt.method,
                headers: opt.headers,
                credentials: opt.cookies ? 'include' : ''
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                return json;
            }).catch(function (ex) {
                return { error: true, url: ex };
            });
        } else {
            return __WEBPACK_IMPORTED_MODULE_6_axios___default()(opt.url + (opt.url.indexOf('?') >= 0 ? '&' : '?') + param, {
                method: opt.method,
                timeout: opt.timeout,
                withCredentials: opt.cookies,
                headers: opt.headers
            }).then(function (response) {
                return response.data;
            }).catch(function (ex) {
                return { error: true, url: ex };
            });
        }
    } else {
        return __WEBPACK_IMPORTED_MODULE_6_axios___default()(opt.url, {
            method: opt.method,
            timeout: opt.timeout,
            data: opt.paramType == 0 ? param : opt.param,
            withCredentials: opt.cookies,
            headers: opt.headers
        }).then(function (response) {
            return response.data;
        }).catch(function (ex) {
            return { error: true, url: ex };
        });
    }
};

Apm.prototype.molg = function (data) {

    var _ts = this,
        pageData = _ts.pageData,
        _appid = pageData._appid,
        _udid = pageData._udid,
        _uid = pageData._uid,
        _v = pageData._v,
        _version = pageData._version,
        _webcode = pageData._webcode,
        url = '';
    for (var key in data) {
        url += '&' + key + '=' + encodeURIComponent(data[key]);
    }
    if (pageData._uid && pageData._appid && pageData._udid) {
        url += '&_appid=' + _appid + '&_udid=' + _udid + '&_uid=' + _uid + '&_v=' + _v + '&_version=' + _version + '&_webcode=' + _webcode;
    }
    url = url.substring(1);

    new Image().src = '//stat.myzaker.com/stat_h5.php?' + url;
};

Apm.prototype.timeSince = function (dateStr) {
    var formatStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd hh:mm';

    dateStr = dateStr + '';
    dateStr *= dateStr.length === 10 ? 1000 : 1;
    if (!dateStr) {
        return '';
    }
    var date = new Date(dateStr);
    var recorded = date.valueOf();
    var today = new Date().setHours(0, 0, 0, 0);
    var yesterday = today - A_DAY;
    var theDayBefore = yesterday - A_DAY;
    var now = new Date().valueOf();
    var diffFromRecorded = now - recorded;

    if (diffFromRecorded < A_MINUTE) {
        return '刚刚';
    }

    if (diffFromRecorded < AN_HOUR) {
        return parseInt('' + diffFromRecorded / A_MINUTE) + '分钟前';
    }

    if (diffFromRecorded < now - today) {
        return parseInt('' + diffFromRecorded / AN_HOUR) + '小时前';
    }
    if (diffFromRecorded < now - yesterday) {
        return this.formatTimestamp(dateStr, '昨天 hh:mm');
    }
    if (diffFromRecorded < now - theDayBefore) {
        return this.formatTimestamp(dateStr, '前天 hh:mm');
    }
    return this.formatTimestamp(dateStr, formatStr);
};

Apm.prototype.timeToSec = function (str) {
    if (!str) {
        return 0;
    }
    var arr = str.split(':');
    var sec = 0;
    var length = arr.length - 1;
    for (var i = 0; i <= length; i++) {
        sec = sec + arr[i] * Math.pow(60, length - i);
    }
    return sec;
};

Apm.prototype.formatTimestamp = function (dateStr, str) {
    if (!str) str = 'MM-dd';
    dateStr = dateStr + '';
    dateStr *= dateStr.length === 10 ? 1000 : 1;
    var date = new Date(dateStr);
    var regExArr = ['y+', 'M+', 'd+', 'h+', 'm+', 's+', 'q+', 'S'];
    var resultArr = [date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), Math.floor((date.getMonth() + 3) / 3), date.getMilliseconds()];
    for (var i = 0; i < regExArr.length; i++) {
        var pattern = regExArr[i];
        var result = resultArr[i];
        var regEx = new RegExp('(' + pattern + ')');
        if (regEx.test(str)) {
            if (pattern === 'y+') {
                str = str.replace(regEx, result);
            } else {
                var replaceStr = result.toString();

                replaceStr = this.addO(replaceStr);
                str = str.replace(regEx, replaceStr);
            }
        }
    }
    return str;
};

Apm.prototype.addO = function (str) {
    str = str + '';
    if (str.length > 1) {
        return str;
    }
    var temp = '00' + str;
    return temp.substring(str.length);
};

Apm.prototype.md5 = function (value) {
    var hex_chr = "0123456789abcdef",
        rhex = function rhex(num) {
        var str = "";
        for (var j = 0; j <= 3; j++) {
            str += hex_chr.charAt(num >> j * 8 + 4 & 0x0F) + hex_chr.charAt(num >> j * 8 & 0x0F);
        }return str;
    },
        str2blks_MD5 = function str2blks_MD5(str) {
        var nblk = (str.length + 8 >> 6) + 1;
        var blks = new Array(nblk * 16);
        for (var i = 0; i < nblk * 16; i++) {
            blks[i] = 0;
        }for (var i = 0; i < str.length; i++) {
            blks[i >> 2] |= str.charCodeAt(i) << i % 4 * 8;
        }blks[i >> 2] |= 0x80 << i % 4 * 8;
        blks[nblk * 16 - 2] = str.length * 8;
        return blks;
    },
        add = function add(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF);
        var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xFFFF;
    },
        rol = function rol(num, cnt) {
        return num << cnt | num >>> 32 - cnt;
    },
        cmn = function cmn(q, a, b, x, s, t) {
        return add(rol(add(add(a, q), add(x, t)), s), b);
    },
        ff = function ff(a, b, c, d, x, s, t) {
        return cmn(b & c | ~b & d, a, b, x, s, t);
    },
        gg = function gg(a, b, c, d, x, s, t) {
        return cmn(b & d | c & ~d, a, b, x, s, t);
    },
        hh = function hh(a, b, c, d, x, s, t) {
        return cmn(b ^ c ^ d, a, b, x, s, t);
    },
        ii = function ii(a, b, c, d, x, s, t) {
        return cmn(c ^ (b | ~d), a, b, x, s, t);
    },
        MD5 = function MD5(str) {
        var x = str2blks_MD5(str);
        var a = 1732584193;
        var b = -271733879;
        var c = -1732584194;
        var d = 271733878;

        for (var i = 0; i < x.length; i += 16) {
            var olda = a;
            var oldb = b;
            var oldc = c;
            var oldd = d;

            a = ff(a, b, c, d, x[i + 0], 7, -680876936);
            d = ff(d, a, b, c, x[i + 1], 12, -389564586);
            c = ff(c, d, a, b, x[i + 2], 17, 606105819);
            b = ff(b, c, d, a, x[i + 3], 22, -1044525330);
            a = ff(a, b, c, d, x[i + 4], 7, -176418897);
            d = ff(d, a, b, c, x[i + 5], 12, 1200080426);
            c = ff(c, d, a, b, x[i + 6], 17, -1473231341);
            b = ff(b, c, d, a, x[i + 7], 22, -45705983);
            a = ff(a, b, c, d, x[i + 8], 7, 1770035416);
            d = ff(d, a, b, c, x[i + 9], 12, -1958414417);
            c = ff(c, d, a, b, x[i + 10], 17, -42063);
            b = ff(b, c, d, a, x[i + 11], 22, -1990404162);
            a = ff(a, b, c, d, x[i + 12], 7, 1804603682);
            d = ff(d, a, b, c, x[i + 13], 12, -40341101);
            c = ff(c, d, a, b, x[i + 14], 17, -1502002290);
            b = ff(b, c, d, a, x[i + 15], 22, 1236535329);

            a = gg(a, b, c, d, x[i + 1], 5, -165796510);
            d = gg(d, a, b, c, x[i + 6], 9, -1069501632);
            c = gg(c, d, a, b, x[i + 11], 14, 643717713);
            b = gg(b, c, d, a, x[i + 0], 20, -373897302);
            a = gg(a, b, c, d, x[i + 5], 5, -701558691);
            d = gg(d, a, b, c, x[i + 10], 9, 38016083);
            c = gg(c, d, a, b, x[i + 15], 14, -660478335);
            b = gg(b, c, d, a, x[i + 4], 20, -405537848);
            a = gg(a, b, c, d, x[i + 9], 5, 568446438);
            d = gg(d, a, b, c, x[i + 14], 9, -1019803690);
            c = gg(c, d, a, b, x[i + 3], 14, -187363961);
            b = gg(b, c, d, a, x[i + 8], 20, 1163531501);
            a = gg(a, b, c, d, x[i + 13], 5, -1444681467);
            d = gg(d, a, b, c, x[i + 2], 9, -51403784);
            c = gg(c, d, a, b, x[i + 7], 14, 1735328473);
            b = gg(b, c, d, a, x[i + 12], 20, -1926607734);

            a = hh(a, b, c, d, x[i + 5], 4, -378558);
            d = hh(d, a, b, c, x[i + 8], 11, -2022574463);
            c = hh(c, d, a, b, x[i + 11], 16, 1839030562);
            b = hh(b, c, d, a, x[i + 14], 23, -35309556);
            a = hh(a, b, c, d, x[i + 1], 4, -1530992060);
            d = hh(d, a, b, c, x[i + 4], 11, 1272893353);
            c = hh(c, d, a, b, x[i + 7], 16, -155497632);
            b = hh(b, c, d, a, x[i + 10], 23, -1094730640);
            a = hh(a, b, c, d, x[i + 13], 4, 681279174);
            d = hh(d, a, b, c, x[i + 0], 11, -358537222);
            c = hh(c, d, a, b, x[i + 3], 16, -722521979);
            b = hh(b, c, d, a, x[i + 6], 23, 76029189);
            a = hh(a, b, c, d, x[i + 9], 4, -640364487);
            d = hh(d, a, b, c, x[i + 12], 11, -421815835);
            c = hh(c, d, a, b, x[i + 15], 16, 530742520);
            b = hh(b, c, d, a, x[i + 2], 23, -995338651);

            a = ii(a, b, c, d, x[i + 0], 6, -198630844);
            d = ii(d, a, b, c, x[i + 7], 10, 1126891415);
            c = ii(c, d, a, b, x[i + 14], 15, -1416354905);
            b = ii(b, c, d, a, x[i + 5], 21, -57434055);
            a = ii(a, b, c, d, x[i + 12], 6, 1700485571);
            d = ii(d, a, b, c, x[i + 3], 10, -1894986606);
            c = ii(c, d, a, b, x[i + 10], 15, -1051523);
            b = ii(b, c, d, a, x[i + 1], 21, -2054922799);
            a = ii(a, b, c, d, x[i + 8], 6, 1873313359);
            d = ii(d, a, b, c, x[i + 15], 10, -30611744);
            c = ii(c, d, a, b, x[i + 6], 15, -1560198380);
            b = ii(b, c, d, a, x[i + 13], 21, 1309151649);
            a = ii(a, b, c, d, x[i + 4], 6, -145523070);
            d = ii(d, a, b, c, x[i + 11], 10, -1120210379);
            c = ii(c, d, a, b, x[i + 2], 15, 718787259);
            b = ii(b, c, d, a, x[i + 9], 21, -343485551);

            a = add(a, olda);
            b = add(b, oldb);
            c = add(c, oldc);
            d = add(d, oldd);
        }
        return rhex(a) + rhex(b) + rhex(c) + rhex(d);
    };

    return MD5(value);
};





/* harmony default export */ __webpack_exports__["a"] = (new Apm({ cookies: __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a, fetchJsonp: __WEBPACK_IMPORTED_MODULE_5_fetch_jsonp___default.a, axios: __WEBPACK_IMPORTED_MODULE_6_axios___default.a }));

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    class: ['banner-cover', _vm.type]
  }, [(_vm.type === 'video') ? _c('video', {
    staticClass: "banner-player",
    attrs: {
      "loop": "",
      "autoplay": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.url,
      "type": "video/mp4"
    }
  })]) : _c('img', {
    staticClass: "banner-player",
    attrs: {
      "src": _vm.url,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(225)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(237),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stringSlice */
/* harmony export (immutable) */ __webpack_exports__["a"] = queryStringify;
/* unused harmony export getURLQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createDownload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);


function stringSlice(str, start, end) {
  if (str.length <= end + 1) {
    return str;
  }
  return str.substring(start, end) + "...";
}

function queryStringify(obj) {
  var isEncode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var query = "";
  for (var o in obj) {
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj[0]) == "object") {
      query += "&" + queryStringify(obj[o]);
    } else {
      if (isEncode) {
        query += "&" + o + "=" + encodeURI(obj[o]);
      } else {
        query += "&" + o + "=" + obj[o];
      }
    }
  }
  query = query.substr(1);
  return query;
}

var getURLQuery = function getURLQuery(url) {
  var uri = decodeURI(url);
  return (uri.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(function (a, v) {
    return a[v.slice(0, v.indexOf("="))] = v.slice(v.indexOf("=") + 1), a;
  }, {});
};

var formatTime = function formatTime() {
  var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "mm:ss";

  var hasHour = false;
  if (/(h+)/.test(fmt)) {
    hasHour = true;
  }

  var fixed2 = function fixed2(num) {
    return num >= 10 ? num : "0" + num;
  };

  var d = Math.ceil(duration);
  var s = d % 60;
  var m = parseInt(d / 60);
  var h = 0;
  if (hasHour) {
    h = parseInt(d / (60 * 60));
    m = m - h * 60;

    return fixed2(h) + ":" + fixed2(m) + ":" + fixed2(s);
  }

  return fixed2(m) + ":" + fixed2(s);
};

var createDownload = function createDownload(options) {
  var download_url = options.download_url,
      download_title = options.download_title;


  var xhr = new XMLHttpRequest();
  xhr.open("GET", download_url, true);
  xhr.responseType = "blob";
  xhr.onload = function () {
    var urlCreator = window.URL || window.webkitURL;
    var url = urlCreator.createObjectURL(this.response);
    var tag = document.createElement("a");
    tag.href = url;
    tag.target = "_blank";
    tag.download = "" + download_title;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  };
  xhr.send();
};

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ERR_TEXT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return axiosInterceptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _request; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_view_design__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_view_design___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_view_design__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_axios__ = __webpack_require__(29);






var _this = this;







var ERR_TEXT = "出了点问题，请稍后重试";

var axiosInterceptor = function axiosInterceptor() {
  __WEBPACK_IMPORTED_MODULE_6_axios___default.a.interceptors.request.use(function (config) {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, config, {
      transformRequest: [function (data) {
        data = __WEBPACK_IMPORTED_MODULE_8_qs___default.a.stringify(data);
        return data;
      }]
    });
  });
  __WEBPACK_IMPORTED_MODULE_6_axios___default.a.interceptors.response.use(function (response) {
    var res = response.data;
    __WEBPACK_IMPORTED_MODULE_5_view_design__["Message"].destroy();
    if (!res) {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_5_view_design__["Message"].error('出了点问题，请稍后重试');
      }, 10);
      return;
    }
    if (res.stat == -1) {
      window.location.href = res.data.url;
    } else if (res.stat == 0) {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_5_view_design__["Message"].error(res.msg || '请求失败');
      }, 10);
    }
    return res;
  }, function (error) {
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_5_view_design__["Message"].error('出了点问题，请稍后重试');
    }, 10);
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
  });
};

var _request = function _request() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
      var axiosConfig, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              axiosConfig = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["merge"])({}, __WEBPACK_IMPORTED_MODULE_9__config_axios__["a" /* defaultConfig */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                url: url
              }, options, {
                method: options.method ? options.method.toLowerCase() : 'get'
              }));


              if (axiosConfig.method === 'get') {
                axiosConfig.params = axiosConfig.data;
                delete axiosConfig.data;
              }

              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_6_axios___default()(axiosConfig);

            case 5:
              res = _context.sent;

              resolve(res);
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);

              reject(_context.t0);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 9]]);
    }));

    return function (_x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }());
};

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_view_design__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_view_design___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_view_design__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_view_design_dist_styles_iview_css__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_view_design_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_view_design_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_about_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_about_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_about_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apm__ = __webpack_require__(11);




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_view_design___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_apm__["a" /* default */]);
window.winVue = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({ el: '#root', template: '<App/>', components: { App: __WEBPACK_IMPORTED_MODULE_5__pages_about_vue___default.a } });

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_material_extends__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mock_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Layout__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Header__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Banner__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Banner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Banner__);











/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Layout: __WEBPACK_IMPORTED_MODULE_3__components_Layout___default.a, HeaderComp: __WEBPACK_IMPORTED_MODULE_4__components_Header___default.a, Banner: __WEBPACK_IMPORTED_MODULE_5__components_Banner___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_material_extends__["a" /* default */]],
  data: function data() {
    return {
      searchValue: ''
    };
  },

  methods: {
    handleSearch: function handleSearch(value) {
      this.pushRoute({
        name: 'list',
        params: {
          value: value
        },
        target: '_self'
      });
    }
  },
  computed: {},
  mounted: function mounted() {
    this._setSessionToken();
  }
});

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(62);



var URL_PREFIX = '';
var winPageData = {
  user_info: null,
  org_info: null,
  csrf_token: 'yTl2lha3DZJCibjrDFhizag3cy8vJwWpHQDxsOkv',
  page_info: {
    title: '一起剪素材网站',
    icon: 'https://rmt-videos.mcn123.cn/design-video/image/yiqijianvideoindexfavicon.ico'
  },
  common_api: {
    login_page: 'https://yiqijian-video.dev58.myzaker.com/auth/login'
  },
  nav_links: {
    live_platform: 'https://yiqijian-video.dev58.myzaker.com/live_platform'
  },
  solution: {
    scheme_organize: 'https://yiqijian-video.dev58.myzaker.com/scheme_organize'
  },
  login_page: 'https://yiqijian-video.dev58.myzaker.com/auth/login',
  login_api: 'https://yiqijian-video.dev58.myzaker.com/auth/login',
  loginout_api: 'https://yiqijian-video.dev58.myzaker.com/auth/logout',
  myorg_page: 'https://yiqijian-video.dev58.myzaker.com/home',
  index_page: 'https://yiqijian-video.dev58.myzaker.com/',
  contact: 'https://yiqijian-video.dev58.myzaker.com/contact',
  security: 'https://yiqijian-video.dev58.myzaker.com/security',
  medias: {
    keyword: '超人',
    list: [{
      _id: '60d5a1c873cd9b35eb489810',
      title: '夜间交通繁忙的日本路',
      duration: '7.08',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d5a1c63a1ea.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d5a1c7943c1.jpg',
      create_time: 1624613314,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60d5a1c873cd9b35eb489810.mp4',
      width: 1280,
      height: 720,
      tags: ['交通', '日本'],
      keyword: '交通',
      ext: 'mp4'
    }, {
      _id: '60d3316a73cd9b783a78fd65',
      title: '一架无人机在树林中盘旋的特写镜头',
      duration: '20.853333',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d3316886d46.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d33169380f8.jpg',
      create_time: 1624453478,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60d3316a73cd9b783a78fd65.mp4',
      width: 1280,
      height: 720,
      tags: ['树林', '无人机'],
      keyword: '树林',
      ext: 'mp4'
    }, {
      _id: '60d3077073cd9b6f433872af',
      title: '无人机飞越一大片森林',
      duration: '85.48',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d3076e17124.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d3076fccaa6.jpg',
      create_time: 1624442730,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60d3077073cd9b6f433872af.mp4',
      width: 1280,
      height: 720,
      tags: ['无人机', '森林'],
      keyword: '无人机',
      ext: 'mp4'
    }, {
      _id: '60d2e2e773cd9b6f43386ae5',
      title: '大城市的夜行',
      duration: '15.015',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d2e2e5186df.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d2e2e6703c9.jpg',
      create_time: 1624433378,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60d2e2e773cd9b6f43386ae5.mp4',
      width: 1280,
      height: 720,
      tags: ['城市的'],
      keyword: '城市的',
      ext: 'mp4'
    }, {
      _id: '60d3223473cd9b783a78f91f',
      title: '旅游木板路',
      duration: '17.916667',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d32233c92e5.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d3223480a1e.jpg',
      create_time: 1624449586,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60d3223473cd9b783a78f91f.mp4',
      width: 1280,
      height: 720,
      tags: ['海', '海滨', '旅游'],
      keyword: '海',
      ext: 'mp4'
    }, {
      _id: '60d3325273cd9b783a78fdad',
      title: '在树林中盘旋的无人机的底图',
      duration: '9.408333',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d33250d3440.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d33251f033d.jpg',
      create_time: 1624453710,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60d3325273cd9b783a78fdad.mp4',
      width: 1280,
      height: 720,
      tags: ['树林', '无人机'],
      keyword: '树林',
      ext: 'mp4'
    }, {
      _id: '60d32fc973cd9b783a78fcd3',
      title: '慢慢地从飞机窗口向外张望',
      duration: '10.468333',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d32fc892c56.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d32fc958234.jpg',
      create_time: 1624453063,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60d32fc973cd9b783a78fcd3.mp4',
      width: 1280,
      height: 720,
      tags: ['飞机'],
      keyword: '飞机',
      ext: 'mp4'
    }, {
      _id: '60d32fc973cd9b783a78fcd3',
      title: '慢慢地从飞机窗口向外张望',
      duration: '10.468333',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d32fc892c56.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d32fc958234.jpg',
      create_time: 1624453063,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60d32fc973cd9b783a78fcd3.mp4',
      width: 1280,
      height: 720,
      tags: ['飞机'],
      keyword: '飞机',
      ext: 'mp4'
    }, {
      _id: '60d9dbc173cd9b17f046c12a',
      title: '飓风, 风暴, 卫星图像',
      duration: '11.006667',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d9dbc078207.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d9dbc111e32.jpg',
      create_time: 1624890303,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60d9dbc173cd9b17f046c12a.mp4',
      width: 1280,
      height: 720,
      tags: ['飓风', '风暴', '卫星图像'],
      keyword: '飓风',
      ext: 'mp4'
    }, {
      _id: '60d9b53773cd9b127b7f9dfa',
      title: '冰川, 环礁湖, 冰岛, 冰山一角, 景观, 自然, 冷',
      duration: '22.756067',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d9b5367492e.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d9b5374a0e7.jpg',
      create_time: 1624880436,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60d9b53773cd9b127b7f9dfa.mp4',
      width: 1280,
      height: 720,
      tags: ['冰川', '环礁湖', '冰岛', '冰山一角', '景观', '自然', '冷', '天空', '冰山', '冻结', '湖', 'Jokulsarlon'],
      keyword: '冰川',
      ext: 'mp4'
    }, {
      _id: '60d9bdbf73cd9b127b7fa06b',
      title: '空间, 银河, 宇宙, 星级, 天空, 夜, 背景, 明星',
      duration: '30.015',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d9bdbdf2f80.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d9bdbeb070e.jpg',
      create_time: 1624882620,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60d9bdbf73cd9b127b7fa06b.mp4',
      width: 1280,
      height: 720,
      tags: ['空间', '银河', '宇宙', '星级', '天空', '夜', '背景', '明星', '未来', '星座', '神秘', '蓝色', '无穷大', '天文', '天文学'],
      keyword: '空间',
      ext: 'mp4'
    }, {
      _id: '60d9a2ce73cd9b127b7f9963',
      title: '湖, 山, 自然, 天空, 水, 环境, 旅行, 空中的视图',
      duration: '10.583333',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d9a2cc412cd.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d9a2cdeb35c.jpg',
      create_time: 1624875721,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60d9a2ce73cd9b127b7f9963.mp4',
      width: 1280,
      height: 720,
      tags: ['湖', '山', '自然', '天空', '水', '环境', '旅行', '空中的视图', '全景图', '反思', '风景', '宁静', '田园风光', '景区'],
      keyword: '湖',
      ext: 'mp4'
    }, {
      _id: '60da65fe73cd9b1f8d780e38',
      title: '雨, 大雨, 风暴, 大暴雨, 性质, 雨季',
      duration: '18.73',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60da65fd90960.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60da65fe3f5b1.jpg',
      create_time: 1624925691,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60da65fe73cd9b1f8d780e38.mp4',
      width: 1280,
      height: 720,
      tags: ['雨', '大雨', '风暴', '大暴雨', '性质', '雨季'],
      keyword: '雨',
      ext: 'mp4'
    }, {
      _id: '60da1a7373cd9b17f046d2c4',
      title: '鸭, 海鸥, 苏黎世, 广东, 高山, 瑞士, 夏季, 秋季',
      duration: '10.44',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60da1a72953aa.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60da1a732f18d.jpg',
      create_time: 1624906353,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60da1a7373cd9b17f046d2c4.mp4',
      width: 1280,
      height: 720,
      tags: ['鸭', '海鸥', '苏黎世', '广东', '高山', '瑞士', '夏季', '秋季', '性质', '动物', '水', '休息', '雾', '湖', '鸟类', '水禽'],
      keyword: '鸭',
      ext: 'mp4'
    }, {
      _id: '60da482673cd9b1f8d7805d5',
      title: '牛, 牲畜, 奶牛, 牛肉, 农业, 动物, 哺乳动物',
      duration: '37',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60da482583ab5.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60da48262c83a.jpg',
      create_time: 1624918052,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60da482673cd9b1f8d7805d5.mp4',
      width: 1280,
      height: 720,
      tags: ['牛', '牲畜', '奶牛', '牛肉', '农业', '动物', '哺乳动物', '农村', '农场', '业', '食品', '肉', '牛奶', '农田', '群', '景观'],
      keyword: '牛',
      ext: 'mp4'
    }, {
      _id: '60da482673cd9b1f8d7805d5',
      title: '牛, 牲畜, 奶牛, 牛肉, 农业, 动物, 哺乳动物',
      duration: '37',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60da482583ab5.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60da48262c83a.jpg',
      create_time: 1624918052,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60da482673cd9b1f8d7805d5.mp4',
      width: 1280,
      height: 720,
      tags: ['牛', '牲畜', '奶牛', '牛肉', '农业', '动物', '哺乳动物', '农村', '农场', '业', '食品', '肉', '牛奶', '农田', '群', '景观'],
      keyword: '牛',
      ext: 'mp4'
    }, {
      _id: '60db653773cd9b2f543966c2',
      title: '高山滑雪坡顶',
      duration: '17.687',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60db6536615e7.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60db6536ea5c3.jpg',
      create_time: 1624991028,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60db653773cd9b2f543966c2.mp4',
      width: 1280,
      height: 720,
      tags: ['斯洛文尼亚', '朱利安阿尔卑斯山', '阿尔卑斯山', '山', '雪'],
      keyword: '斯洛文尼亚',
      ext: 'mp4'
    }, {
      _id: '60e012df73cd9b6fac4ce890',
      title: 'gumdrop糖果旋转镜头-糖果GUMDROPS 025',
      duration: '20.48',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60e012de86e9b.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60e012df3ddeb.jpg',
      create_time: 1625297628,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60e012df73cd9b6fac4ce890.mp4',
      width: 630,
      height: 354,
      tags: ['糖果', '口香糖糖', '口香糖'],
      keyword: '糖果',
      ext: 'mp4'
    }, {
      _id: '60dee7d373cd9b4de023f1ac',
      title: '中国澳门天际线',
      duration: '10.6',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60dee7d1c9f7b.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60dee7d2c15fd.jpg',
      create_time: 1625221072,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60dee7d373cd9b4de023f1ac.mp4',
      width: 630,
      height: 354,
      tags: ['天际线', '澳门', '建筑'],
      keyword: '天际线',
      ext: 'mp4'
    }, {
      _id: '60df382173cd9b55461554cc',
      title: '夕阳下的麦田',
      duration: '15.56',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60df382024ad8.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60df3820d7c4e.jpg',
      create_time: 1625241630,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60df382173cd9b55461554cc.mp4',
      width: 630,
      height: 354,
      tags: ['日落', '麦田', '微风'],
      keyword: '日落',
      ext: 'mp4'
    }, {
      _id: '60df502873cd9b58c05d684d',
      title: '动物园里的小羚羊',
      duration: '15.04',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60df5027e597c.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60df502886120.jpg',
      create_time: 1625247782,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60df502873cd9b58c05d684d.mp4',
      width: 630,
      height: 354,
      tags: ['头', '动物园', '栖息地', '动物', '羚羊', '自然'],
      keyword: '头',
      ext: 'mp4'
    }, {
      _id: '60dbd89773cd9b45654f8c12',
      title: '冰岛北极北欧夜景天性天文学天空岛峡湾性质户外挪威晚上景观极光水反射海岸漂亮灯光灯火磁性绿色的天空美丽自然华美颜色显示风景',
      duration: '26.366667',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60dbd894edaa6.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60dbd8962a87c.jpg',
      create_time: 1625020561,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60dbd89773cd9b45654f8c12.mp4',
      width: 720,
      height: 720,
      tags: ['冰岛', '北极', '北欧', '夜景', '天性', '天文学', '天空', '岛', '峡湾', '性质', '户外', '挪威', '晚上', '景观', '极光', '水反射', '海岸', '漂亮', '灯光', '灯火', '磁性', '绿色的天空', '美丽', '自然', '华美', '颜色', '显示', '风景'],
      keyword: '冰岛',
      ext: 'mp4'
    }, {
      _id: '60e0937d73cd9b7e5d2bae3a',
      title: '土土壤地球表面地质地质学坍方大石头天性山岩石岩石形成岩石的巨石性质悬崖悬崖边户外日光日视频明亮景观有岩石的松散的岩石泥土洛矶山脉滑坡特写环境白天石头的聚焦拍摄自然视力近距拍摄阳光颜色风景',
      duration: '16.76',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60e0937be19b4.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60e0937ca3f51.jpg',
      create_time: 1625330554,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60e0937d73cd9b7e5d2bae3a.mp4',
      width: 1280,
      height: 720,
      tags: ['土', '土壤', '地球表面', '地质', '地质学', '坍方', '大石头', '天性', '山', '岩石', '岩石形成', '岩石的', '巨石', '性质', '悬崖', '悬崖边', '户外', '日光', '日视频', '明亮', '景观', '有岩石的', '松散的岩石', '泥土', '洛矶山脉', '滑坡', '特写', '环境', '白天', '石头的', '聚焦拍摄', '自然', '视力', '近距拍摄', '阳光', '颜色', '风景'],
      keyword: '土',
      ext: 'mp4'
    }, {
      _id: '60dfc0c473cd9b63d93760c7',
      title: '剪影天性天空太阳性质户外日出日落晚间景观漂亮环境田美景美丽自然草草原草地农地农村运动场地云风景麦田黄昏黎明',
      duration: '10.751667',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60dfc0c38e9bf.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60dfc0c42b92f.jpg',
      create_time: 1625276610,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60dfc0c473cd9b63d93760c7.mp4',
      width: 1280,
      height: 720,
      tags: ['剪影', '天性', '天空', '太阳', '性质', '户外', '日出', '日落', '晚间', '景观', '漂亮', '环境', '田', '美景', '美丽', '自然', '草', '草原', '草地', '农地', '农村', '运动场地', '云', '风景', '麦田', '黄昏', '黎明'],
      keyword: '剪影',
      ext: 'mp4'
    }, {
      _id: '60d9a2ce73cd9b127b7f9963',
      title: '湖, 山, 自然, 天空, 水, 环境, 旅行, 空中的视图',
      duration: '10.583333',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d9a2cc412cd.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d9a2cdeb35c.jpg',
      create_time: 1624875721,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60d9a2ce73cd9b127b7f9963.mp4',
      width: 1280,
      height: 720,
      tags: ['湖', '山', '自然', '天空', '水', '环境', '旅行', '空中的视图', '全景图', '反思', '风景', '宁静', '田园风光', '景区'],
      keyword: '湖',
      ext: 'mp4'
    }, {
      _id: '60dbd6e773cd9b45654f8bc7',
      title: '地平线地理地质构造坏心情梦想天性天空山山峰山火山山脉岛从上面心情低落性质旅行旅游无人机相机无人机视频机动木船横的水水平的海岸线湖湖岸湖边漂亮火山无人机无人空拍机热带热带的环境田园白米白饭砂空拍机连续镜头米绊倒美景美丽自然自然摄影自然桌面农村阴沉云风景风景如画惊人',
      duration: '15.573333',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60dbd6e536aed.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60dbd6e68b63f.jpg',
      create_time: 1625020130,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60dbd6e773cd9b45654f8bc7.mp4',
      width: 1280,
      height: 720,
      tags: ['地平线', '地理', '地质构造', '坏心情', '梦想', '天性', '天空', '山', '山峰', '山火山', '山脉', '岛', '从上面', '心情低落', '性质', '旅行', '旅游', '无人机相机', '无人机视频', '机动木船', '横的', '水', '水平的', '海岸线', '湖', '湖岸', '湖边', '漂亮', '火山', '无人机', '无人空拍机', '热带', '热带的', '环境', '田园', '白米', '白饭', '砂', '空拍机连续镜头', '米', '绊倒', '美景', '美丽', '自然', '自然摄影', '自然桌面', '农村', '阴沉', '云', '风景', '风景如画', '惊人'],
      keyword: '地平线',
      ext: 'mp4'
    }, {
      _id: '60e12be773cd9b0fa374becb',
      title: '土地地平线天性太阳山坡山谷性质户外日光景观晴天晴朗晴朗的天空树木水水路河河边美景自然蓝天农村乡村陆地阳光风景高地',
      duration: '12.8128',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60e12be64bb2e.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60e12be711e7b.jpg',
      create_time: 1625369572,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60e12be773cd9b0fa374becb.mp4',
      width: 1280,
      height: 720,
      tags: ['土地', '地平线', '天性', '太阳', '山坡', '山谷', '性质', '户外', '日光', '景观', '晴天', '晴朗', '晴朗的天空', '树木', '水', '水路', '河', '河边', '美景', '自然', '蓝天', '农村', '乡村', '陆地', '阳光', '风景', '高地'],
      keyword: '土地',
      ext: 'mp4'
    }, {
      _id: '60e08b9f73cd9b7b41527390',
      title: '食物木木头原本景观风景水夏季夏天花园农业草捲心菜叶子树河旅行湿花颜色医学烟抽烟户外环境植物群增长蔬菜成长生长绿花椰菜新鲜郁郁葱葱',
      duration: '7.440767',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60e08b9e78a10.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60e08b9f23c77.jpg',
      create_time: 1625328540,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60e08b9f73cd9b7b41527390.mp4',
      width: 1366,
      height: 720,
      tags: ['食物', '木', '木头', '原本', '景观', '风景', '水', '夏季', '夏天', '花园', '农业', '草', '捲心菜', '叶子', '树', '河', '旅行', '湿', '花', '颜色', '医学', '烟', '抽烟', '户外', '环境', '植物群', '增长', '蔬菜', '成长', '生长', '绿花椰菜', '新鲜', '郁郁葱葱'],
      keyword: '食物',
      ext: 'mp4'
    }, {
      _id: '60dbc0a773cd9b45654f87b1',
      title: '4k低角度拍摄夜间天文学天空天体宇宙广角拍摄户外时间流逝明星星形星星晚上树木气氛流星浸入白色漂亮漆黑美景美丽银河阴暗云风景风景如画黑暗',
      duration: '17.050367',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60dbc0a5de4d9.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60dbc0a6c33e5.jpg',
      create_time: 1625014434,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60dbc0a773cd9b45654f87b1.mp4',
      width: 1280,
      height: 720,
      tags: ['4k', '低角度拍摄', '夜间', '天文学', '天空', '天体', '宇宙', '广角拍摄', '户外', '时间流逝', '明星', '星形', '星星', '晚上', '树木', '气氛', '流星', '浸入白色', '漂亮', '漆黑', '美景', '美丽', '银河', '阴暗', '云', '风景', '风景如画', '黑暗'],
      keyword: '4k',
      ext: 'mp4'
    }, {
      _id: '60dbdcb473cd9b45654f8cc0',
      title: '光光线公园动物友谊哺乳动物国内天性太阳女人季节家庭的宠物小路性质慢动作户外摇摄日落景观林地森林树木树林步行犬狗秋天美女自然调味走路轻的农村阳光颜色风景黎明',
      duration: '18.125',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60dbdcb0dc0da.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60dbdcb231dae.jpg',
      create_time: 1625021614,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60dbdcb473cd9b45654f8cc0.mp4',
      width: 1280,
      height: 720,
      tags: ['光', '光线', '公园', '动物', '友谊', '哺乳动物', '国内', '天性', '太阳', '女人', '季节', '家庭的', '宠物', '小路', '性质', '慢动作', '户外', '摇摄', '日落', '景观', '林地', '森林', '树木', '树林', '步行', '犬', '狗', '秋天', '美女', '自然', '调味', '走路', '轻的', '农村', '阳光', '颜色', '风景', '黎明'],
      keyword: '光',
      ext: 'mp4'
    }, {
      _id: '60dbdcb473cd9b45654f8cc0',
      title: '光光线公园动物友谊哺乳动物国内天性太阳女人季节家庭的宠物小路性质慢动作户外摇摄日落景观林地森林树木树林步行犬狗秋天美女自然调味走路轻的农村阳光颜色风景黎明',
      duration: '18.125',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60dbdcb0dc0da.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60dbdcb231dae.jpg',
      create_time: 1625021614,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60dbdcb473cd9b45654f8cc0.mp4',
      width: 1280,
      height: 720,
      tags: ['光', '光线', '公园', '动物', '友谊', '哺乳动物', '国内', '天性', '太阳', '女人', '季节', '家庭的', '宠物', '小路', '性质', '慢动作', '户外', '摇摄', '日落', '景观', '林地', '森林', '树木', '树林', '步行', '犬', '狗', '秋天', '美女', '自然', '调味', '走路', '轻的', '农村', '阳光', '颜色', '风景', '黎明'],
      keyword: '光',
      ext: 'mp4'
    }, {
      _id: '60e1284b73cd9b0fa374bdaf',
      title: '地平线多风天性性质招手挥手日落景观模糊的水波浪浅焦点海景海洋海浪海滨海滩砂美景自然阳光风风景黄昏黄金时段',
      duration: '31.721667',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60e1284a09b86.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60e1284ac7dcb.jpg',
      create_time: 1625368648,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60e1284b73cd9b0fa374bdaf.mp4',
      width: 1280,
      height: 720,
      tags: ['地平线', '多风', '天性', '性质', '招手', '挥手', '日落', '景观', '模糊的', '水', '波浪', '浅焦点', '海景', '海洋', '海浪', '海滨', '海滩', '砂', '美景', '自然', '阳光', '风', '风景', '黄昏', '黄金时段'],
      keyword: '地平线',
      ext: 'mp4'
    }, {
      _id: '60e01d6773cd9b6fac4cebf4',
      title: '人优美的风景剪影天空女人市容建筑慢动作推球日落机架焦点漆黑视线水准阴暗风景风景如画馀辉黄昏黄金时段黑暗',
      duration: '21.695',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60e01d66484f9.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60e01d66e4f03.jpg',
      create_time: 1625300324,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60e01d6773cd9b6fac4cebf4.mp4',
      width: 1280,
      height: 720,
      tags: ['人', '优美的风景', '剪影', '天空', '女人', '市容', '建筑', '慢动作', '推球', '日落', '机架焦点', '漆黑', '视线水准', '阴暗', '风景', '风景如画', '馀辉', '黄昏', '黄金时段', '黑暗'],
      keyword: '人',
      ext: 'mp4'
    }, {
      _id: '60f8207873cd9b287b75e3cd',
      title: '瑞典的风景。湖光山色，日落，鸟语花香。',
      duration: '19.2',
      cover_200: 'https://rmt-videos.mcn123.cn/collect/cover_photo/202107/2873ff6ede206f072e20fe09331dc284_200.jpeg',
      cover_640: 'https://rmt-videos.mcn123.cn/collect/cover_photo/202107/2873ff6ede206f072e20fe09331dc284_640.jpeg',
      create_time: 1626873976,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202110/60f8207873cd9b287b75e3cd.mp4',
      width: 1920,
      height: 1080,
      tags: ['宁静的', '背景', '湖', '橙色', '鸟', '风景', '宁静', '日落', '瑞典'],
      keyword: '宁静的',
      ext: 'mp4'
    }, {
      _id: '60f81f8673cd9b287b75dc14',
      title: '在日出的映衬下，山上风景如画的鸟瞰图',
      duration: '6.167',
      cover_200: 'https://rmt-videos.mcn123.cn/collect/cover_photo/202107/0a509d4a073a6cab58116f66337e029b_200.jpeg',
      cover_640: 'https://rmt-videos.mcn123.cn/collect/cover_photo/202107/0a509d4a073a6cab58116f66337e029b_640.jpeg',
      create_time: 1626873734,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202110/60f81f8673cd9b287b75dc14.mp4',
      width: 1920,
      height: 1080,
      tags: ['山', '日出', '风景'],
      keyword: '山',
      ext: 'mp4'
    }, {
      _id: '60f81f4773cd9b281d402b9f',
      title: '风景如画的峡谷中的山湖。阿勒泰风景和自然的空中视频拍摄。',
      duration: '21.422',
      cover_200: 'https://rmt-videos.mcn123.cn/collect/cover_photo/202107/753c3f50ecc02b546fca68fee2113c72_200.jpeg',
      cover_640: 'https://rmt-videos.mcn123.cn/collect/cover_photo/202107/753c3f50ecc02b546fca68fee2113c72_640.jpeg',
      create_time: 1626873671,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202110/60f81f4773cd9b281d402b9f.mp4',
      width: 1920,
      height: 1080,
      tags: ['自然', '风景如画的', '山', '峡谷'],
      keyword: '自然',
      ext: 'mp4'
    }, {
      _id: '60d9f3e873cd9b17f046c7d3',
      title: '白熊, 累, 睡眠, 动物园, 白, 肖像, 休眠, 北极熊',
      duration: '27.733333',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d9f3e774d1b.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d9f3e8139d0.jpg',
      create_time: 1624896485,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60d9f3e873cd9b17f046c7d3.mp4',
      width: 1280,
      height: 720,
      tags: ['白熊', '累', '睡眠', '动物园', '白', '肖像', '休眠', '北极熊', '气候变化', '北极'],
      keyword: '白熊',
      ext: 'mp4'
    }, {
      _id: '60d9a21673cd9b127b7f992b',
      title: '猫, 小猫, 宠物, 基蒂, 哺乳动物, 好玩, 玩猫',
      duration: '50.73',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d9a215298a2.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60d9a21608b60.jpg',
      create_time: 1624875539,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60d9a21673cd9b127b7f992b.mp4',
      width: 1280,
      height: 720,
      tags: ['猫', '小猫', '宠物', '基蒂', '哺乳动物', '好玩', '玩猫', '可爱', '毛皮', '播放', '动物'],
      keyword: '猫',
      ext: 'mp4'
    }, {
      _id: '60498a5d5d8b5475573a14b7',
      title: '走在绿色山谷里的豹子',
      duration: '28.0',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202103/a28cba8bf57ec88054bffa47a8018e6e.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202103/d3f173eca1630ac64180166309e2c912.jpg',
      create_time: 1615432285,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202102/86d9e28c0461fdfb29d9d6c80d1b979e8e26a703.mp4',
      width: 1280,
      height: 720,
      tags: ['野生动物', '动物', '山谷', '猫'],
      keyword: '野生动物',
      ext: ''
    }, {
      _id: '60df6c5673cd9b5c3f64be2e',
      title: '享受冒险动物南非可爱哺乳动物在水下天性好奇的家人家庭家庭成员密封封口小狗小羚羊岛少年年轻幼犬底部性质爱打听的爱玩的慢动作斗清单有求知慾的栖息地标记水水上冒险水下水下摄影水活动水生动物没有人泡沫泡泡浅浮潜海海岸海带海洋海洋动物海洋生物海洋野生动物海狮海藻海豹游泳潜水潟湖特写玩耍生物多样性自然舞台剧表面调皮请享用豪特湾近距拍摄遭遇野生野生动物野生动物摄影野生摄影师开普敦非洲惊人盐水',
      duration: '19.3193',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60df6c5576b8d.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60df6c5609c63.jpg',
      create_time: 1625254996,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202109/60df6c5673cd9b5c3f64be2e.mp4',
      width: 1280,
      height: 720,
      tags: ['享受', '冒险', '动物', '南非', '可爱', '哺乳动物', '在水下', '天性', '好奇的', '家人', '家庭', '家庭成员', '密封', '封口', '小狗', '小羚羊岛', '少年', '年轻', '幼犬', '底部', '性质', '爱打听的', '爱玩的', '慢动作', '斗清单', '有求知慾的', '栖息地', '标记', '水', '水上冒险', '水下', '水下摄影', '水活动', '水生动物', '没有人', '泡沫', '泡泡', '浅', '浮潜', '海', '海岸', '海带', '海洋', '海洋动物', '海洋生物', '海洋野生动物', '海狮', '海藻', '海豹', '游泳', '潜水', '潟湖', '特写', '玩耍', '生物多样性', '自然', '舞台剧', '表面', '调皮', '请享用', '豪特湾', '近距拍摄', '遭遇', '野生', '野生动物', '野生动物摄影', '野生摄影师', '开普敦', '非洲', '惊人', '盐水'],
      keyword: '享受',
      ext: 'mp4'
    }, {
      _id: '60eea3cd73cd9b46726907f2',
      title: '海浪',
      duration: '18.394',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60eea3cca0e60.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60eea3cd55d6b.jpg',
      create_time: 1626252234,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202107/60eea3cd73cd9b46726907f2.mp4',
      width: 1920,
      height: 1080,
      tags: ['催眠', '美丽的', '海洋', '波浪', '巨浪', '天堂', '深蓝', '水', '海岸', '街道', '夏季', '滑水', '冲浪者', '冲浪', '冲浪板', '旅行', '假日', '假期', '目的地', '探索', '阳光', '日出', '日落', '天线', '无人机', '自然', '背景'],
      keyword: '催眠',
      ext: 'mp4'
    }, {
      _id: '604723e25d8b5417c2075430',
      title: '深圳摩天大楼闪烁的灯光',
      duration: '7.0',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202103/d3ab16d682730dbb15b78d1f294250f5.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202103/b3394d92ab71a276f269d63b45b9afa3.jpg',
      create_time: 1615274978,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202102/6db56b1248d02cc5e806943173fe5beef776068f.mp4',
      width: 1280,
      height: 720,
      tags: ['海洋', '海湾', '西蒂', '建筑', '闪光', '摩天大楼', '亚洲', '中国', '深圳'],
      keyword: '海洋',
      ext: ''
    }, {
      _id: '60eff4de73cd9b78252de671',
      title: '爷爷奶奶和小女孩在公园里散步。孙辈和祖父母花时间在夏季自然背景上。和爷爷奶奶一起过暑假快乐。',
      duration: '11.479',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60eff4dda4b98.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60eff4de63663.jpg',
      create_time: 1626338523,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202108/60eff4de73cd9b78252de671.mp4',
      width: 1920,
      height: 1080,
      tags: ['背景', '自然', '公园', '一起', '祖父母', '祖父', '时间', '夏季', '女孩'],
      keyword: '背景',
      ext: 'mp4'
    }, {
      _id: '60b7253173cd9b201672e9e9',
      title: '雪山鸟瞰图。冬季雪景',
      duration: '21.455',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60b72530c5907.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60b72531697cc.jpg',
      create_time: 1622615343,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202107/60b7253173cd9b201672e9e9.mp4',
      width: 1920,
      height: 1080,
      tags: ['雪山'],
      keyword: '雪山',
      ext: 'mp4'
    }, {
      _id: '60b9c08773cd9b3eee716e8b',
      title: '极地雪山落基山脉位于寒冷的极地地区',
      duration: '29.867',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60b9c0869600f.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60b9c0874d025.jpg',
      create_time: 1622786181,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202107/60b9c08773cd9b3eee716e8b.mp4',
      width: 1920,
      height: 1080,
      tags: ['雪山'],
      keyword: '雪山',
      ext: 'mp4'
    }, {
      _id: '6046ff075d8b545cbe05b392',
      title: '深圳公路交通中的骑士',
      duration: '8.0',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202103/27161a6de3f94b65a35b515e99b4b180.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202103/2b96583b7f08cfb4338d8579f49a9f13.jpg',
      create_time: 1615265543,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202102/43150fdc6ad7d40695b48379ca64cd85ef0cc167.mp4',
      width: 1280,
      height: 720,
      tags: ['深圳', '交通'],
      keyword: '深圳',
      ext: ''
    }, {
      _id: '60ba41be73cd9b3f0a3a8ccf',
      title: '黄昏时分，4K超高清空中飞过森林中的树木',
      duration: '9.258',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60ba41bd57053.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60ba41be02aaf.jpg',
      create_time: 1622819259,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202108/60ba41be73cd9b3f0a3a8ccf.mp4',
      width: 1920,
      height: 1080,
      tags: ['林中'],
      keyword: '林中',
      ext: 'mp4'
    }, {
      _id: '60ba7a2373cd9b5074721ead',
      title: '鸟瞰无人驾驶飞机飞越神奇的峡谷山河。戏剧性的秋季自然景观。绿色的草地，橘黄色的小山，松林映衬着夕阳的天空。喀尔巴阡山，乌克兰，欧洲。4千',
      duration: '28.829',
      cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60ba7a22692f2.jpg',
      cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202106/60ba7a2318a52.jpg',
      create_time: 1622833696,
      rank: 0,
      watermark_url: 'https://rmt-videos.mcn123.cn/collect/video/202108/60ba7a2373cd9b5074721ead.mp4',
      width: 1920,
      height: 1080,
      tags: ['乌克兰'],
      keyword: '乌克兰',
      ext: 'mp4'
    }],
    total: 10000
  },
  media_info: {
    _id: '60ec13855d8b547523475b63',
    title: '2021中共中央国务院举行春节团拜会',
    duration: 27.23333,
    ext: 'mp4',
    cover_200: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60ec138317399.jpg',
    cover_640: 'https://rmt-videos.mcn123.cn/design-video/video_cover/202107/60ec138457ab6.jpg',
    create_time: 1626084224,
    rank: 1000,
    watermark_url: 'https://rmt-oss.myzaker.com/dev58/images/202107/7fxA7d_1626084161533.mp4',
    width: 1920,
    height: 1080,
    keyword: '超人',
    tags: ['习主席']
  },
  domain_info: {
    detail_page: '/media-detail.html',
    index_page: '/',
    list_page: '/media-list.html'
  }
};

if (false) {
  window.WinPageData = _Object$assign({}, winPageData, common);
}

/* unused harmony default export */ var _unused_webpack_default_export = (winPageData);

/***/ }),

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return localStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sessionStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);






var Storage = function () {
  function Storage(storage) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Storage);

    this.storage = storage;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Storage, [{
    key: 'setItem',
    value: function setItem(key, value) {
      var expire = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var val = {
        data: value,
        expire: expire
      };
      val = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(val);
      this.storage.setItem(key, val);
    }
  }, {
    key: 'setItems',
    value: function setItems(payload) {
      var _this = this;

      var expireArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if ((typeof payload === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(payload)) !== 'object' || Array.isArray(payload)) {
        throw new Error('payload is not object.');
      }

      if (!Array.isArray(expireArr)) {
        throw new Error('expireArr is not Array.');
      }

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key, index) {
        _this.setItem(key, payload[key], expireArr[index]);
      });
    }
  }, {
    key: 'getItem',
    value: function getItem(key) {
      var value = this.storage.getItem(key);
      value = JSON.parse(value);

      return value;
    }
  }, {
    key: 'getItems',
    value: function getItems() {
      var _this2 = this;

      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (!Array.isArray(keys)) {
        throw new Error('keys is not array.');
      }

      var values = {};
      if (keys.length) {
        keys.forEach(function (key) {
          values[key] = _this2.getItem(key);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.storage).forEach(function (key) {
          values[key] = _this2.getItem(key);
        });
      }

      return values;
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key) {
      this.storage.removeItem(key);
    }
  }, {
    key: 'removeExpireItem',
    value: function removeExpireItem(key) {
      var _this3 = this;

      var isExact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var keyRE = isExact ? new RegExp('^' + key + '$') : new RegExp('' + key, 'g');
      var currentTimeStamp = parseInt(Date.now() / 1000);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.storage).forEach(function (key) {
        if (!keyRE.test(key)) return;

        var temp = _this3.getItem(key);

        if (temp.expire && temp.expire < currentTimeStamp) {
          _this3.removeItem(key);
        }
      });
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.storage.clear();
    }
  }, {
    key: 'isExistItem',
    value: function isExistItem(key) {
      return this.getItem(key) !== null ? true : false;
    }
  }, {
    key: 'isExpire',
    value: function isExpire(key) {
      var currentTimeStamp = parseInt(Date.now() / 1000);
      var value = this.getItem(key);
      if (!value || !value.expire || value.expire <= currentTimeStamp) {
        return false;
      }

      return true;
    }
  }]);

  return Storage;
}();

var localStorage = new Storage(window.localStorage);
var sessionStorage = new Storage(window.sessionStorage);

/***/ }),

/***/ 225:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-page"
  }, [_c('Layout', {
    attrs: {
      "winPageData": _vm.winPageData,
      "footerVisible": false
    }
  }, [_c('header-comp', {
    attrs: {
      "searchValue": _vm.searchValue,
      "visibilityHeight": 320,
      "headerClass": "header-white",
      "gradual": ""
    },
    on: {
      "update:searchValue": function($event) {
        _vm.searchValue = $event
      },
      "update:search-value": function($event) {
        _vm.searchValue = $event
      },
      "search": _vm.handleSearch
    }
  }), _vm._v(" "), _c('banner', {
    attrs: {
      "height": 410,
      "url": "https://yiqijian.com/assets/images/header-bg.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about-container"
  }, [_c('article', {
    staticClass: "agreement-article"
  }, [_c('h3', {
    staticClass: "article-title"
  }, [_vm._v("授权许可协议")]), _vm._v(" "), _c('p', [_vm._v("以下是您作为被授权人（以下简称\"您\"）与色值（广州）新媒体科技有限公司（以下简称“色值公司”）之间就您被授权许可下载、使用色值公司提供的视觉版权素材（以下简称“素材”），即“本服务”所达成的双方协议（以下简称“本协议”）。在使用色值公司提供的视觉版权素材之前，请仔细阅读本协议条款。一旦您进行下载等行为，即表明您同意并接受本协议的全部条款的约束，认可所有的权利和义务。")]), _vm._v(" "), _c('p', [_vm._v("色值公司有权在必要时修订本协议条款，然后在网站相关页面上提示修改内容。如果您不同意所改动的内容，您有权停止使用。如果您继续使用本协议项下色值公司的服务，则视为接受相关条款的变动。")]), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_vm._v("一、版权声明")]), _vm._v(" "), _c('p', [_vm._v("本网站展示的视觉版权素材著作权归属于色值公司及资源提供方（包括图片资源商、供图作者等）合法享有，受中华人民共和国知识产权法律以及其他相关法律法规保护。")]), _vm._v(" "), _c('p', [_vm._v("经相应的授权许可，您对本网站视觉版权素材享有非独家的、非排他性的、不可转让的、不可转许可的、在授权地域内永久使用的权利。")]), _vm._v(" "), _c('p', [_vm._v("本协议为单一授权许可，仅允许一位自然人或法人用户下载及使用素材，您必须是素材的最终使用者即最终授权用户，不得进行二次授权或转授权。如果您需要获取超过一个自然人或法人的使用权限，或本协议下的授权不能满足需求，请联系色值公司进行授权升级。")]), _vm._v(" "), _c('p', [_vm._v("本协议对视觉版权素材的授权许可使用,不视为所有权或版权已转让给被授权人；除本协议中明确陈述的授权之外，色值公司未授予被授权人对版权素材的其他任何权利。")]), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_vm._v("二、定义")]), _vm._v(" "), _c('p', [_vm._v("本协议中的“被授权人”，指愿意接受本协议、同意按本协议的约定下载并使用视觉版权素材的人（包括自然人、法人、非法人的各类组织等）。")]), _vm._v(" "), _c('p', [_vm._v("特别提示：本协议项下被授权人仅限中国大陆地区（不包含香港、澳门、台湾地区）用户主体，非中国大陆地区主体下载本网站版权素材内容无法获得相应授权；如被授权人违反本约定，所造成的后果与色值公司无关。")]), _vm._v(" "), _c('p', [_vm._v("本协议的“授权”，指非独家的、非排他性的、不可转让的、不可转许可的、在授权地域内永久使用的权利。")]), _vm._v(" "), _c('p', [_vm._v("本协议的“授权地域”，指使用的地域范围为全球。")]), _vm._v(" "), _c('p', [_vm._v("本协议中的“视觉版权素材”，简称“素材”，指具有独创性并能以某种有形形式复制的版权素材，包括但不限于摄影照片、漫画、绘画、动态图、矢量、字体、视频以及其他版权素材。")]), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_vm._v("三、扩展授权")]), _vm._v(" "), _c('p', [_vm._v("在扩展授权范围下，您可以将视觉版权素材用于标准许可下所有允许的用途，以及以下其他使用范围，具体包括：")]), _vm._v(" "), _c('p', [_vm._v("1. 杂志、书籍等封面、封底印刷；")]), _vm._v(" "), _c('p', [_vm._v("2. 将素材或者利用素材创作的衍生作品，用在实物商品、网络商品、赠品等（统称为“商品”）中用于销售或分销，包括但不限于明信片、日历、装饰品、艺术品、服饰、玩具、生活用品、墙纸、产品包装等实物商品，以及软件程序、设计模板、壁纸、主题皮肤、课件等网络商品；")]), _vm._v(" "), _c('p', [_vm._v("3. 媒体应用：任何网剧、网络视频、网络直播、电影、电视节目、公共表演等；")]), _vm._v(" "), _c('p', [_vm._v("4. 户外广告：如易拉宝、灯箱、橱窗、车身、楼宇、户外广告牌等。")]), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_vm._v("四、授权限制")]), _vm._v(" "), _c('p', [_vm._v("您不得超出授权协议条款所约定和允许的使用范围。")]), _vm._v(" "), _c('p', [_vm._v("您不得将本网站素材用于任何商业目的，包括但不限于任何商业活动、任何形式的广告宣传、商标或产品推广、促销等。")]), _vm._v(" "), _c('p', [_vm._v("您不得将本网站素材用于任何违反国家法律法规、社会公序良俗、色情淫秽、不道德和或侵犯第三人合法权利的用途。")]), _vm._v(" "), _c('p', [_vm._v("您不得将本网站素材用于敏感的场景，对图片中人物造成冒犯或贬低，包括但不限于：暗示心理和生理缺陷、暗示性方面的活动或喜好、犯罪、身体或精神虐待或疾病。")]), _vm._v(" "), _c('p', [_vm._v("您不得使用以下的方式描述本网站素材中出现的任何人物，亦不得将本网站素材用于以下用途，否则产生的后果与色值公司无关：")]), _vm._v(" "), _c('p', [_vm._v("1. 与淫秽色情作品、成人娱乐场所、陪伴服务、约会服务、美容整容、医疗保健品类等有关；")]), _vm._v(" "), _c('p', [_vm._v("2. 参与烟草、酒精产品的广告或促销；")]), _vm._v(" "), _c('p', [_vm._v("3. 患有生理或心理疾病或用药治疗生理或心理疾病；")]), _vm._v(" "), _c('p', [_vm._v("4. 从事不道德或违法犯罪活动；")]), _vm._v(" "), _c('p', [_vm._v("5. 其他可能涉嫌侮辱、诽谤等贬损素材中人物的名誉、伤害人物情感或合法权益的方式。")]), _vm._v(" "), _c('p', [_vm._v("您不得使用素材（部分或全部）作为官方商标、其他商业标识、logo或其他原产地标识，或上述各项的部分，或以其他方式对任何产品或服务进行背书或暗示背书。")]), _vm._v(" "), _c('p', [_vm._v("您不得转售、转让、再分发、转授权或与第三方共享本网站素材使用权。")]), _vm._v(" "), _c('p', [_vm._v("您不得以明示或暗示的方式，虚假声明素材由色值公司或素材版权持有人之外的他人所创作。")]), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_vm._v("五、被授权人责任")]), _vm._v(" "), _c('p', [_vm._v("您应当充分理解本协议中各项条款，保证有权利签订本协议，否则您在本网站的活动将被视违约行为。")]), _vm._v(" "), _c('p', [_vm._v("您可以将本网站素材交给第三方，按照本授权协议条款的要求进行打印和制作包含本网站素材的商品，但您必须是最终用户，并且应当采取合理的商业措施防止第三方复制和使用任何素材。")]), _vm._v(" "), _c('p', [_vm._v("您理解并同意，对于因将素材用于本协议未明确允许的用途所导致的任何损害赔偿或其他法律责任，您都将向色值公司及色值公司的资源提供方承担责任并赔偿全部损失。")]), _vm._v(" "), _c('p', [_vm._v("您理解并同意，在使用本网站素材时由于您的个人行为对第三方造成侵权或引发其他赔偿，色值公司不承担任何责任，因为您的行为对色值公司造成的损失您需要一并进行赔偿。")]), _vm._v(" "), _c('p', [_vm._v("您理解并同意，如果您违反与色值公司之间订立的本协议或任何其他协议的条款，而因此产生一切费用和开支，您都将对色值公司进行补偿。")]), _vm._v(" "), _c('p', [_vm._v("当您违反了本协议中的条款，本网站有权终止您的账户以及本网站的其他合法权利。")]), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_vm._v("六、网站有限责任")]), _vm._v(" "), _c('p', [_vm._v("本网站保证对基于本协议所许可您使用的素材享有合法的著作权或已获得著作权人的合法授权")]), _vm._v(" "), _c('p', [_vm._v("本网站仅对素材本身作出保证，对于被授权人修改素材内容或超出授权范围使用素材而导致的任何后果，本网站不承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "sub-title"
  }, [_vm._v("七、用户使用规范")]), _vm._v(" "), _c('p', [_vm._v("在使用本网站提供的服务前您需要按照相关提示进行注册，本网站将给予您一个账号及相应的密码，该账号的所有权归色值公司所有，仅您本人可以获得该账号的使用权，不得赠与、借用、租用、转让、出售或以其他方式许可他人使用您的账号。")]), _vm._v(" "), _c('p', [_vm._v("您在注册成为本网站用户时，必须提供准确的个人资料，并负有及时更新的义务,同时请您负责妥善保管用户账号和密码,您应当对以其用户账号进行的所有活动和事件承担法律责任，本网站有权随时监控使用状态，当发现您的账号出现多人使用或其他异常使用的情况，本网站将有权随时关闭您的账号。")]), _vm._v(" "), _c('p', [_vm._v("八、其他事项")]), _vm._v(" "), _c('p', [_vm._v("本协议自双方签订之日起生效，于本网站账号正式关闭之日终止。")]), _vm._v(" "), _c('p', [_vm._v("本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。若您和本网站发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交广州市天河区人民法院诉讼解决。")]), _vm._v(" "), _c('p', [_vm._v("本协议所有条款的标题仅为阅读方便，本身并无实际含义，不能作为本协议含义解释的依据。")]), _vm._v(" "), _c('p', [_vm._v("本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。")]), _vm._v(" "), _c('p', [_vm._v("本协议最终解释权归色值公司所有。")])])]), _vm._v(" "), _c('div', {
    staticClass: "about-footer"
  }, [_vm._v("Copyright© 2020 ZAKER.ALL Rights Reserved")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(40)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(50),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(41)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(51),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

var requireAll = function requireAll(requireContext) {
  return requireContext.keys().map(requireContext);
};
var req = __webpack_require__(56);

requireAll(req);

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_storage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_enum__ = __webpack_require__(1);




var defaultConfig = {
  method: 'get',
  headers: {
    'X-CSRF-TOKEN': __WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* sessionStorage */].isExistItem(__WEBPACK_IMPORTED_MODULE_1__utils_enum__["a" /* USER_INFO */]) ? __WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* sessionStorage */].getItem(__WEBPACK_IMPORTED_MODULE_1__utils_enum__["a" /* USER_INFO */]).data : ''
  }
};

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(14);






var DEV_58 = 'https://yiqijian-video.dev58.myzaker.com';
var PROD = 'https://creative.yiqijian.com';

var route = {
  dev: {
    index: './index.html',
    list: './media-list.html',
    detail: './media-detail.html',
    about: './about.html',
    error: './error.html'
  },
  dev58: {
    index: DEV_58,
    list: DEV_58 + '/videos',
    detail: DEV_58 + '/detail',
    about: DEV_58 + '/about',
    error: DEV_58 + '/404'
  },
  prod: {
    index: PROD,
    list: PROD + '/videos',
    detail: PROD + '/detail',
    about: PROD + '/about',
    error: PROD + '/404'
  }
};

var ZkRouter = function () {
  function ZkRouter(route) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ZkRouter);

    this.route = route;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ZkRouter, [{
    key: '_getBaseUrl',
    value: function _getBaseUrl(name) {
      if (!name) return '';

      var domain = '';
      if (false) {
        domain = this.route.dev[name];
      } else if (location.href.indexOf('yiqijian-video.dev58.myzaker.com') != -1) {
        domain = this.route.dev58[name];
      } else {
        domain = this.route.prod[name];
      }

      return domain || '';
    }
  }, {
    key: 'getRoute',
    value: function getRoute(_ref) {
      var name = _ref.name,
          _ref$path = _ref.path,
          path = _ref$path === undefined ? '' : _ref$path,
          params = _ref.params,
          query = _ref.query;

      var url = '';

      if (name) {
        var baseUrl = this._getBaseUrl(name);

        var extra = '';

        if (params && "production" !== 'development') {
          for (var key in params) {
            if (Object.hasOwnProperty.call(params, key)) {
              extra = extra + '/' + params[key];
            }
          }
        }

        url = '' + (baseUrl + extra);
      } else {
        var _baseUrl = location.href.split('?')[0];
        url = '' + (_baseUrl + path);
      }

      var queryStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* queryStringify */])(query, true);
      return queryStr ? url + '?' + queryStr : url;
    }
  }, {
    key: 'push',
    value: function push(_ref2) {
      var name = _ref2.name,
          _ref2$path = _ref2.path,
          path = _ref2$path === undefined ? '' : _ref2$path,
          params = _ref2.params,
          query = _ref2.query,
          _ref2$target = _ref2.target,
          target = _ref2$target === undefined ? '_blank' : _ref2$target;

      var _queryObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, query);
      var hashObj = null;

      if (_queryObj.hash) {
        hashObj = _queryObj.hash;
        delete _queryObj.hash;
      }

      var url = this.getRoute({ name: name, path: path, params: params, query: _queryObj });

      if (hashObj) {
        var hashStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* queryStringify */])(hashObj).replace('&', '#');
        url += hashStr;
      }

      if (target === '_blank') {
        window.open(url);
      } else {
        window.location.href = url;
      }
    }
  }]);

  return ZkRouter;
}();

/* harmony default export */ __webpack_exports__["a"] = (new ZkRouter(route));

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_feather_icons__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ZkBackTop',
  components: {
    ChevronUpIcon: __WEBPACK_IMPORTED_MODULE_0_vue_feather_icons__["c" /* ChevronUpIcon */]
  }
});

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_feather_icons__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchInput__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SearchInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SvgIcon_vue__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SvgIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SvgIcon_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["a" /* default */]],
  props: {
    gradual: {
      type: Boolean,
      default: false
    },
    headerClass: {
      type: String,
      default: ''
    },
    searchValue: {
      type: String,
      default: ''
    },

    visibilityHeight: {
      type: Number,
      default: 0
    }
  },
  computed: {
    headerStyle: function headerStyle() {
      if (!this.gradual) return;

      var styles = {
        backgroundColor: 'rgba(255, 255, 255, ' + this.opacity + ')'
      };

      if (this.opacity >= 0.5) {
        styles.color = 'rgba(51, 51, 51, ' + this.opacity + ')';
      }

      if (this.opacity >= 1) {
        styles.boxShadow = '0px 4px 16px 0px rgba(0, 0, 0, 0.05)';
      }

      return styles;
    },
    showSearch: function showSearch() {
      if (!this.visibilityHeight) return true;
      if (this.visibilityHeight < 0) return false;

      return this.visibilityHeight && this.searchVisible;
    }
  },
  data: function data() {
    return {
      opacity: 0,
      searchVisible: false,
      productList: [{
        id: 1,
        label: '行业资讯汇聚',
        value: 'https://www.yiqijian.com/hot-news'
      }, {
        id: 2,
        label: '海量剪辑素材',
        value: 'https://www.yiqijian.com/material'
      }, {
        id: 3,
        label: '网络视频提取',
        value: 'https://www.yiqijian.com/video-collector'
      }, {
        id: 4,
        label: '实时视频热榜',
        value: 'https://www.yiqijian.com/hot-videos'
      }, {
        id: 5,
        label: '视频模板定制',
        value: 'https://www.yiqijian.com/video-templates'
      }, {
        id: 6,
        label: '智能在线剪辑',
        value: 'https://www.yiqijian.com/smart-editor'
      }, {
        id: 7,
        label: '字幕语音播报',
        value: 'https://www.yiqijian.com/auto-sounds'
      }, {
        id: 8,
        label: '视频云端合成',
        value: 'https://www.yiqijian.com/cloud-maker'
      }, {
        id: 9,
        label: '视频一键发布',
        value: 'https://www.yiqijian.com/one-step'
      }, {
        id: 10,
        label: '团队管理',
        value: 'https://www.yiqijian.com/team-manager'
      }],
      serviceList: [{
        id: 1,
        label: '私有部署',
        value: 'https://www.yiqijian.com/deploy'
      }, {
        id: 2,
        label: '开放接入',
        value: 'https://www.yiqijian.com/open-access'
      }, {
        id: 3,
        label: '融媒体解决方案',
        value: 'http://rongmeiti.myzaker.com/'
      }]
    };
  },

  methods: {
    handleChangeSearch: function handleChangeSearch(value) {
      this.$emit('update:searchValue', value);
    },
    handleSearch: function handleSearch(value) {
      this.$emit('search', value);
    },
    _handleScroll: function _handleScroll() {
      if (!this.visibilityHeight || this.visibilityHeight < 0) return;

      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var ratio = (scrollTop / this.visibilityHeight).toFixed(2);
      var opacity = ratio >= 1 ? 1 : ratio >= 0.8 ? 0.8 : ratio;
      this.opacity = opacity;
      this.searchVisible = scrollTop >= this.visibilityHeight;
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this._handleScroll);
  },
  beforeMount: function beforeMount() {
    window.removeEventListener('scroll', this._handleScroll);
  },

  components: {
    Trash2Icon: __WEBPACK_IMPORTED_MODULE_1_vue_feather_icons__["b" /* Trash2Icon */],
    SearchInput: __WEBPACK_IMPORTED_MODULE_2__SearchInput___default.a,
    SvgIcon: __WEBPACK_IMPORTED_MODULE_3__SvgIcon_vue___default.a
  }
});

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BackTop__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BackTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BackTop__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Layout",
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  props: {
    winPageData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    footerVisible: {
      type: Boolean,
      default: true
    }
  },
  methods: {},
  components: {
    ZkFooter: __WEBPACK_IMPORTED_MODULE_0__Footer___default.a,
    ZkBackTop: __WEBPACK_IMPORTED_MODULE_1__BackTop___default.a
  }
});

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_feather_icons__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_storage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_enum__ = __webpack_require__(1);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: String,
      default: ''
    },
    openHistory: {
      type: Boolean,
      default: true
    },
    prefix: {
      type: String
    },
    suffix: {
      type: String
    }
  },
  computed: {
    disabledPoptip: function disabledPoptip() {
      if (!this.openHistory) return true;

      return !this.searchHistory || !this.searchHistory.length;
    }
  },
  data: function data() {
    return {
      searchVisible: false,
      searchHistory: []
    };
  },

  methods: {
    handleChangeSearch: function handleChangeSearch(event) {
      var value = event.target.value;

      this.$emit('change', value);
    },
    handleClearSearch: function handleClearSearch() {
      this.$emit('change', '');
    },
    handleSearch: function handleSearch(e) {
      var value = e.target.value;

      if (this.openHistory) {
        if (this.searchHistory.includes(value)) {
          var index = this.searchHistory.findIndex(function (item) {
            return item === value;
          });

          if (index >= 0) {
            this.searchHistory.splice(index, 1);
          }
        }
        this.searchHistory.unshift(value);
        __WEBPACK_IMPORTED_MODULE_2__utils_storage__["b" /* localStorage */].setItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["b" /* SEARCH_HISTORY */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.searchHistory));
      }

      this.$emit('search', value);

      this.$refs['search-input'].blur();
    },
    handleTagTap: function handleTagTap(tagValue) {
      this.$emit('change', tagValue);

      this.$emit('search', tagValue);
      this.$refs['search-input'].blur();
    },
    handleClearHistory: function handleClearHistory() {
      this.searchHistory = [];
      __WEBPACK_IMPORTED_MODULE_2__utils_storage__["b" /* localStorage */].setItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["b" /* SEARCH_HISTORY */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.searchHistory));
    },
    handleHidePopper: function handleHidePopper() {
      var isExist = __WEBPACK_IMPORTED_MODULE_2__utils_storage__["b" /* localStorage */].isExistItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["b" /* SEARCH_HISTORY */]);
      var historyTags = isExist ? JSON.parse(__WEBPACK_IMPORTED_MODULE_2__utils_storage__["b" /* localStorage */].getItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["b" /* SEARCH_HISTORY */]).data) : '';
      if (!Array.isArray(historyTags)) {
        historyTags = [];
      }
      this.searchHistory = historyTags;
    }
  },
  mounted: function mounted() {
    if (!this.openHistory) return;
    this.handleHidePopper();
  },

  components: {
    Trash2Icon: __WEBPACK_IMPORTED_MODULE_1_vue_feather_icons__["b" /* Trash2Icon */]
  }
});

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_icons_index__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_icons_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_icons_index__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SvgIcon',
  props: {
    name: {
      default: '',
      type: String
    }
  },
  computed: {
    iconName: function iconName() {
      var name = this.name;
      if (name) {
        return '#icon-' + name;
      } else {
        return '#icon-icon';
      }
    }
  }
});

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_zkRouter_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_storage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_enum__ = __webpack_require__(1);





var AXIOS_INIT = false;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      winPageData: window.WinPageData
    };
  },
  created: function created() {
    if (!AXIOS_INIT) {
      __WEBPACK_IMPORTED_MODULE_0__utils_request_js__["b" /* axiosInterceptor */].call(this);
      AXIOS_INIT = true;
    }
  },

  computed: {
    isDevEnv: function isDevEnv() {
      return "production" == 'development';
    }
  },
  methods: {
    pushRoute: function pushRoute(options) {
      __WEBPACK_IMPORTED_MODULE_1__config_zkRouter_js__["a" /* default */].push(options);
    },
    getRoute: function getRoute(options) {
      return __WEBPACK_IMPORTED_MODULE_1__config_zkRouter_js__["a" /* default */].getRoute(options);
    },
    _setSessionToken: function _setSessionToken() {
      __WEBPACK_IMPORTED_MODULE_2__utils_storage__["a" /* sessionStorage */].setItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["a" /* USER_INFO */], this.winPageData.csrf_token);
    }
  }
});

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-icon-hot",
  "use": "icon-icon-hot-usage",
  "viewBox": "0 0 32 16",
  "content": "<symbol viewBox=\"0 0 32 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-hot\"><g fill=\"none\" fill-rule=\"evenodd\"><rect fill=\"#FF4D4F\" width=\"32\" height=\"16\" rx=\"4\" /><path d=\"M7.112 12V8.557h3.938V12h1.243V4.19H11.05v3.267H7.112V4.19H5.88V12h1.232zm10.186.055c.535 0 1.032-.106 1.49-.319a3.71 3.71 0 0 0 1.194-.875 4.1 4.1 0 0 0 1.067-2.755 4 4 0 0 0-.27-1.441 4.328 4.328 0 0 0-.759-1.276 3.689 3.689 0 0 0-1.177-.913 3.381 3.381 0 0 0-1.523-.341c-.535 0-1.032.108-1.49.325a3.78 3.78 0 0 0-1.194.88c-.337.37-.601.792-.792 1.264a3.95 3.95 0 0 0-.286 1.491 4.178 4.178 0 0 0 1.034 2.733c.33.378.722.677 1.177.897.455.22.964.33 1.529.33zm.011-1.111a2.28 2.28 0 0 1-1.82-.864 2.97 2.97 0 0 1-.501-.918 3.289 3.289 0 0 1-.005-2.101c.113-.337.276-.642.489-.913a2.39 2.39 0 0 1 .781-.649c.308-.161.66-.242 1.056-.242.374 0 .713.077 1.017.231.305.154.567.365.787.632.22.268.387.572.5.913a3.335 3.335 0 0 1 .006 2.09c-.11.341-.27.65-.479.925a2.306 2.306 0 0 1-.775.654c-.308.161-.66.242-1.056.242zM25.46 12V5.279h2.596V4.19H21.61v1.089h2.607V12h1.243z\" fill=\"#FFF\" fill-rule=\"nonzero\" opacity=\".9\" /></g></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(43)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(53),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(39)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(49),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(42)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(52),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(54),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 49:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['header', {
      'header-bg': !_vm.gradual
    }, _vm.headerClass],
    style: (_vm.headerStyle)
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "header-nav"
  }, [_c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "https://yiqijian.com",
      "title": "免费视频剪辑 - 一起剪"
    }
  }, [_vm._v("\n        免费视频剪辑\n        "), _c('SvgIcon', {
    staticClass: "icon-hot",
    attrs: {
      "name": "icon-hot"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('Dropdown', [_c('a', {
    staticClass: "nav-label",
    attrs: {
      "href": "javascript:void(0)",
      "title": "产品"
    }
  }, [_vm._v("\n            产品\n            "), _c('Icon', {
    attrs: {
      "type": "ios-arrow-down"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-list product",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_vm._l((_vm.productList), function(item) {
    return [_c('a', {
      key: item.id,
      staticClass: "dropdown-item",
      attrs: {
        "href": item.value,
        "title": item.label,
        "target": "_blank"
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n              ")])]
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('Dropdown', [_c('a', {
    staticClass: "nav-label",
    attrs: {
      "href": "javascript:void(0)",
      "title": "合作"
    }
  }, [_vm._v("\n            合作\n            "), _c('Icon', {
    attrs: {
      "type": "ios-arrow-down"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-list",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_vm._l((_vm.serviceList), function(item) {
    return [_c('a', {
      key: item.id,
      staticClass: "dropdown-item",
      attrs: {
        "href": item.value,
        "title": item.label,
        "target": "_blank"
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n              ")])]
  })], 2)])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "search-box"
  }, [_c('SearchInput', {
    attrs: {
      "prefix": "ios-search",
      "value": _vm.searchValue,
      "openHistory": ""
    },
    on: {
      "change": _vm.handleChangeSearch,
      "search": _vm.handleSearch
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "right"
  }, [(false) ? _c('a', {
    staticClass: "reset-btn login",
    attrs: {
      "href": "//mp.yiqijian.com",
      "title": "一起剪"
    }
  }, [_vm._v("\n      登录\n    ")]) : _vm._e(), _vm._v(" "), (false) ? _c('a', {
    staticClass: "reset-btn register",
    attrs: {
      "href": "//account.yiqijian.com/auth/register?referer=https%3A%2F%2Fmp.yiqijian.com%2Fdashboard",
      "title": "一起剪"
    }
  }, [_vm._v("\n      注册\n    ")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/",
      "title": "一起剪"
    }
  }, [_c('h1', {
    attrs: {
      "title": "一起剪"
    }
  }, [_vm._v("一起剪")])])
}]}

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "zk-footer"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备20059828号-2")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "float": "left",
      "margin": "0 5px 0 0px"
    },
    attrs: {
      "src": "//www.myzaker.com/images/new/bottom/ga.png"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602009154",
      "target": "_blank"
    }
  }, [_vm._v("粤公网安备 44010602009154号")])]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:support@myzaker.com"
    }
  }, [_vm._v("举报邮箱：yu998926@163.com")])])
}]}

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Poptip', {
    staticClass: "search-poptip",
    attrs: {
      "trigger": "focus",
      "placement": "bottom",
      "padding": "24px",
      "disabled": _vm.disabledPoptip
    },
    on: {
      "on-popper-hide": _vm.handleHidePopper
    }
  }, [_c('Input', {
    ref: "search-input",
    staticClass: "search-input",
    attrs: {
      "prefix": _vm.prefix,
      "suffix": _vm.suffix,
      "value": _vm.value,
      "placeholder": "点击搜索视频",
      "size": "large",
      "clearable": ""
    },
    on: {
      "on-change": _vm.handleChangeSearch,
      "on-enter": _vm.handleSearch,
      "on-clear": _vm.handleClearSearch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-board",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "history-list"
  }, [_c('div', {
    staticClass: "list-header"
  }, [_c('div', {
    staticClass: "list-label"
  }, [_vm._v("最近搜索")]), _vm._v(" "), _c('div', {
    staticClass: "clean-btn"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchHistory && _vm.searchHistory.length),
      expression: "searchHistory && searchHistory.length"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleClearHistory
    }
  }, [_c('trash-2-icon', {
    staticClass: "icon-trash",
    attrs: {
      "size": "16"
    }
  }), _vm._v(" "), _c('span', [_vm._v("清空记录")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tag-list"
  }, [_vm._l((_vm.searchHistory), function(item, index) {
    return [_c('span', {
      key: index,
      staticClass: "history-tag",
      on: {
        "click": function($event) {
          return _vm.handleTagTap(item)
        }
      }
    }, [_vm._v(_vm._s(item))])]
  })], 2)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-layout"
  }, [_c('div', {
    staticClass: "layout-container"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.footerVisible) ? _c('div', {
    staticClass: "zk-footer-wrap"
  }, [_c('zk-footer')], 1) : _vm._e(), _vm._v(" "), _c('zk-back-top')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('BackTop', {
    attrs: {
      "height": 150,
      "bottom": 80,
      "right": 80
    }
  }, [_c('div', {
    staticClass: "float-btn back-top"
  }, [_c('chevron-up-icon', {
    staticClass: "icon-chevron-up",
    attrs: {
      "size": "1.5x"
    }
  })], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-help-box"
  }, [_c('a', {
    staticClass: "float-btn report",
    attrs: {
      "href": "https://support.qq.com/products/297963"
    }
  }, [_c('i', {
    staticClass: "icon-shield"
  }), _vm._v(" "), _c('span', [_vm._v("举报")])])])
}]}

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.iconName) ? _c('svg', {
    staticClass: "svg-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.iconName
    }
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

var host = location.host == '' ? '' : location.protocol+'//'+location.host;
var path_res = location.host == '' ? './' : host+"/pc/yiqijian-video/";

const config = {
  API_URL: (location.hostname == 'localhost')? 'http://rongmeiti.dev58.myzaker.com' : location.protocol+'//'+location.host,
  APP_UA: 'ZKRMT', //UA识别 ZKRMT/1.0 ； 以前的com.dio.rmt  
  APP_KEY: 'Tgj8FxWIT4RWhhcq',
  APP_AKEY: 'Bearer',
  HOST: host, //http://xx.xxx.com
  HOST_RES: path_res //http://xx.xxx.com/xxx/
}
module.exports = config


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icon-hot.svg": 44
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchMaterialList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchDownloadInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchVerifyCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchCheckVerifyCode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_request__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_storage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_enum__ = __webpack_require__(1);





var fetchMaterialList = function fetchMaterialList(payload) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_request__["a" /* _request */])('/medias', {
    method: 'post',
    data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload, {
      '_token': __WEBPACK_IMPORTED_MODULE_2__utils_storage__["a" /* sessionStorage */].getItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["a" /* USER_INFO */]).data || ''
    }),
    headers: {
      'X-CSRF-TOKEN': __WEBPACK_IMPORTED_MODULE_2__utils_storage__["a" /* sessionStorage */].isExistItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["a" /* USER_INFO */]) ? __WEBPACK_IMPORTED_MODULE_2__utils_storage__["a" /* sessionStorage */].getItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["a" /* USER_INFO */]).data : ''
    }
  });
};

var fetchDownloadInfo = function fetchDownloadInfo(payload) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_request__["a" /* _request */])('/media_download', {
    method: 'post',
    data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload, {
      '_token': __WEBPACK_IMPORTED_MODULE_2__utils_storage__["a" /* sessionStorage */].getItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["a" /* USER_INFO */]).data || ''
    }),
    headers: {
      'X-CSRF-TOKEN': __WEBPACK_IMPORTED_MODULE_2__utils_storage__["a" /* sessionStorage */].isExistItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["a" /* USER_INFO */]) ? __WEBPACK_IMPORTED_MODULE_2__utils_storage__["a" /* sessionStorage */].getItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["a" /* USER_INFO */]).data : ''
    }
  });
};

var fetchVerifyCode = function fetchVerifyCode(payload) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_request__["a" /* _request */])('/verification/create', {
    method: 'get',
    data: payload,
    headers: {
      'X-CSRF-TOKEN': __WEBPACK_IMPORTED_MODULE_2__utils_storage__["a" /* sessionStorage */].isExistItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["a" /* USER_INFO */]) ? __WEBPACK_IMPORTED_MODULE_2__utils_storage__["a" /* sessionStorage */].getItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["a" /* USER_INFO */]).data : ''
    }
  });
};

var fetchCheckVerifyCode = function fetchCheckVerifyCode(payload) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_request__["a" /* _request */])('/verification/check', {
    method: 'post',
    data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload, {
      '_token': __WEBPACK_IMPORTED_MODULE_2__utils_storage__["a" /* sessionStorage */].getItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["a" /* USER_INFO */]).data || ''
    }),
    headers: {
      'X-CSRF-TOKEN': __WEBPACK_IMPORTED_MODULE_2__utils_storage__["a" /* sessionStorage */].isExistItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["a" /* USER_INFO */]) ? __WEBPACK_IMPORTED_MODULE_2__utils_storage__["a" /* sessionStorage */].getItem(__WEBPACK_IMPORTED_MODULE_3__utils_enum__["a" /* USER_INFO */]).data : ''
    }
  });
};

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_material__ = __webpack_require__(57);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      materialList: [],
      pagination: {
        page: 1,
        pageSize: 48,
        total: 0,
        hasMore: true
      },
      searchValue: ''
    };
  },

  methods: {
    getMaterialList: function getMaterialList() {
      var _this = this;

      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.loading = true;
                if (refresh) {
                  _this.pagination = {
                    page: 1,
                    pageSize: 48,
                    total: 0,
                    hasMore: true
                  };
                  _this.materialList = [];
                }

                if (_this.pagination.hasMore) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                _context.next = 7;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_material__["a" /* fetchMaterialList */])({
                  page: _this.pagination.page,
                  size: _this.pagination.pageSize,
                  keyword: _this.searchValue
                });

              case 7:
                res = _context.sent;

                if (!(res.stat !== 1)) {
                  _context.next = 11;
                  break;
                }

                _this.pagination.hasMore = false;
                return _context.abrupt('return');

              case 11:

                _this.materialList = _this.materialList.concat(res.data.list);

                _this.pagination.page++;
                _this.pagination.total = res.data.total;

                if (_this.materialList.length >= res.data.total) {
                  _this.pagination.hasMore = false;
                }
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](0);

                _this.pagination.hasMore = false;
                console.error(_context.t0);

              case 21:
                _context.prev = 21;

                _this.loading = false;
                return _context.finish(21);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 17, 21, 24]]);
      }))();
    },
    handleMore: function handleMore() {
      if (!this.pagination.hasMore || this.loading) {
        return;
      }

      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      if (scrollTop + clientHeight + 200 >= scrollHeight) {
        this.getMaterialList();
      }
    }
  }
});

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var BASE_URL = "//dev58.myzaker.com/mlab.myzaker.com/";

/* unused harmony default export */ var _unused_webpack_default_export = ({
  common_api: {
    login_api: "http://rongmeiti.dev58.myzaker.com/auth/login",
    login_page: "http://rongmeiti.dev58.myzaker.com/auth/login",
    loginout_api: "http://rongmeiti.dev58.myzaker.com/auth/logout",
    myorg_page: "http://rongmeiti.dev58.myzaker.com/home",
    system_authlogin: "http://rongmeiti.dev58.myzaker.com/system_authlogin",
    yuqing_eventlist: "http://rongmeiti.dev58.myzaker.com/yuqing_eventlist",

    org_user_list_api: "http://rongmeiti-saas.dev58.myzaker.com/admin/org/user/list",
    org_user_role_list_api: "http://rongmeiti-saas.dev58.myzaker.com/admin/org/user/role/list",
    org_user_add_api: "http://rongmeiti-saas.dev58.myzaker.com/admin/org/user/add",
    org_user_edit_api: "http://rongmeiti-saas.dev58.myzaker.com/admin/org/user/edit",
    org_children_tree: "http://rongmeiti-saas.dev58.myzaker.com/admin/org/children/tree",

    auth_password_reset_page: "http://rongmeiti-saas.dev58.myzaker.com/auth/password/reset",

    org_sync_list_api: "http://rongmeiti-saas.dev58.myzaker.com/admin/org/sync/user/list",
    org_retry_api: "http://rongmeiti-saas.dev58.myzaker.com/admin/org/sync/user/retry"
  },
  user_info: {
    nickname: "demo",
    uid: 9052
  },
  login_page: "/auth/login",
  login_api: "/auth/login",
  loginout_api: "/auth/logout",
  myorg_page: "/home",
  index_page: "/",
  mobile_client: "mobile-client.html",

  cloud_design: "/cloud-design.html",
  nav_links: {
    index: "/",
    live_platform: "/live-platform.html",
    make_platform: "/make-platform.html",
    mobile_client: "/mobile-client.html"
  },
  solution: {
    scheme_organize: "/scheme-organize.html",
    scheme_party: "/scheme-party.html",
    scheme_politics: "/scheme-politics.html",
    scheme_traffic: "/scheme-traffic.html",
    scheme_school: "/scheme-school.html"
  },
  article_list: [{
    pk: "604b0787b15ec034bd2b378e",
    summary: "作为原著粉，我对《赘婿》的看法经历了四个阶段。\n普通小说 —— 优秀小说 —— 半部名著 —— 优秀小说\n七八年前，我还上中专呢，一个偶然的机会看到了《赘婿》，此时，它在我心中是本普通小说。\n后来读到一夜鱼龙舞那一段，心中大呼过瘾，尤其是到了灭梁山剧情，我心中已经认为这是本极其优秀的小说了。",
    agree_counts: 4,
    comment_counts: 4,
    date: 1615529656,
    type: "a",
    item_type: "f_1",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "1014阅读",
    show_info: {
      show_type: "1_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/604b0787b15ec034bd2b378f_640.jpg",
        src: "http://zkres.myzaker.com/202103/604b0787b15ec034bd2b378f_640.jpg",
        w: "690",
        h: "388"
      }],
      medias_count: 1
    },
    app_id: 10866,
    title: "杀皇帝？灭梁山！500 万字《赘婿》小说原著，剧情到底有多精彩？",
    content: "",
    content_desc: "作为原著粉，我对《赘婿》的看法经历了四个阶段。普通小说 —— 优秀小说 —— 半部名著 —— 优秀小说七八年前，我还上中专呢，一个偶然的机会看到了《赘婿》，此时，它在我心中是本普通小说。后来读到一夜鱼龙舞那一段，心中大呼过瘾，尤其是到了灭梁山剧情，我心中已经认为这是本极其优秀的小说了。",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=604b0787b15ec034bd2b378e",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "604b0787b15ec034bd2b378e"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=604b0787b15ec034bd2b378e"
  }, {
    pk: "6049f048b15ec044296b8662",
    summary: "“抖人能有夺笋呢” ​​​​（@吃笋勿忘夺笋人）\n",
    agree_counts: 8,
    comment_counts: 14,
    date: 1615458296,
    type: "a",
    item_type: "f_1",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "1.46万阅读",
    show_info: {
      show_type: "1_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049f048b15ec044296b866b_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049f048b15ec044296b866b_640.jpg",
        w: "1024",
        h: "832"
      }],
      medias_count: 1
    },
    app_id: 10866,
    title: "“抖人能有夺笋呢” ​​​​",
    content: "",
    content_desc: "“抖人能有夺笋呢” ​​​​（@吃笋勿忘夺笋人）",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=6049f048b15ec044296b8662",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "6049f048b15ec044296b8662"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=6049f048b15ec044296b8662"
  }, {
    pk: "6049ef3c8e9f09345231f8b8",
    summary: "",
    agree_counts: 11,
    comment_counts: 5,
    date: 1615457828,
    type: "a",
    item_type: "f_1",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "2.09万阅读",
    show_info: {
      show_type: "1_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049ef3c8e9f09345231f8b9_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049ef3c8e9f09345231f8b9_640.jpg",
        w: "750",
        h: "609"
      }],
      medias_count: 1
    },
    app_id: 10866,
    title: "食堂里温馨的一幕",
    content: "",
    content_desc: "",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=6049ef3c8e9f09345231f8b8",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "6049ef3c8e9f09345231f8b8"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=6049ef3c8e9f09345231f8b8"
  }, {
    pk: "6049ee0b8e9f093651017795",
    summary: "该矿场总规模 21 万台矿机，每 100 台显卡矿机 24 小时可以产出 2.7 个以太坊，按照当前 ETH 价格和美元汇率计算，折合 100 太矿机一天营收 3.07 万元。\n2021 年伊始，由于全球晶圆短缺造成显卡价格飙升，目前性能中上的显卡价格也要在 3000-5000 元左右，新款甚至被炒到了 8000-10000 元。",
    agree_counts: 3,
    comment_counts: 29,
    date: 1615457763,
    type: "a",
    item_type: "f_9",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "2.03万阅读",
    show_info: {
      show_type: "4_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049ee0b8e9f093651017797_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049ee0b8e9f093651017797_640.jpg",
        w: "335",
        h: "500"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049ee0b8e9f093651017799_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049ee0b8e9f093651017799_640.jpg",
        w: "364",
        h: "500"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049ee0b8e9f09365101779d_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049ee0b8e9f09365101779d_640.jpg",
        w: "489",
        h: "640"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049ee0b8e9f09365101779e_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049ee0b8e9f09365101779e_640.jpg",
        w: "640",
        h: "336"
      }],
      medias_count: 4
    },
    app_id: 10866,
    title: "四川某加密币矿场实拍图曝光：100台矿机一天可赚 3万元 总共有21万台矿机",
    content: "",
    content_desc: "该矿场总规模 21 万台矿机，每 100 台显卡矿机 24 小时可以产出 2.7 个以太坊，按照当前 ETH 价格和美元汇率计算，折合 100 太矿机一天营收 3.07 万元。2021 年伊始，由于全球晶圆短缺造成显卡价格飙升，目前性能中上的显卡价格也要在 3000-5000 元左右，新款甚至被炒到了 8000-10000 元。",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=6049ee0b8e9f093651017795",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "6049ee0b8e9f093651017795"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=6049ee0b8e9f093651017795"
  }, {
    pk: "6049ee0b8e9f0935ef6b9148",
    summary: "",
    agree_counts: 7,
    comment_counts: 10,
    date: 1615457603,
    type: "a",
    item_type: "f_9",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "2.35万阅读",
    show_info: {
      show_type: "3_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049ee0b8e9f0935ef6b9149_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049ee0b8e9f0935ef6b9149_640.jpg",
        w: "1024",
        h: "768"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049ee0b8e9f0935ef6b914a_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049ee0b8e9f0935ef6b914a_640.jpg",
        w: "1024",
        h: "768"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049ee0b8e9f0935ef6b914b_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049ee0b8e9f0935ef6b914b_640.jpg",
        w: "1024",
        h: "768"
      }],
      medias_count: 3
    },
    app_id: 10866,
    title: "说吧，人类！你今天有什么要求？",
    content: "",
    content_desc: "",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=6049ee0b8e9f0935ef6b9148",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "6049ee0b8e9f0935ef6b9148"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=6049ee0b8e9f0935ef6b9148"
  }, {
    pk: "6049ece98e9f09363c577d75",
    summary: "推友 ヤナマリ 以自己为例，推荐了《健身环大冒险》两个塑造腰部曲线的运动：高举双臂侧弯 和 俯身划船。她曾通过低碳水饮食配合《健身环大冒险》和《Fitness Boxing》，一年内减重 30 KG！",
    agree_counts: 5,
    comment_counts: 11,
    date: 1615457360,
    type: "a",
    item_type: "f_9",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "8292阅读",
    show_info: {
      show_type: "3_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049ece98e9f09363c577d76_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049ece98e9f09363c577d76_640.jpg",
        w: "360",
        h: "203"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049ece98e9f09363c577d78_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049ece98e9f09363c577d78_640.jpg",
        w: "360",
        h: "203"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049ece98e9f09363c577d7b_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049ece98e9f09363c577d7b_640.jpg",
        w: "1024",
        h: "1170"
      }],
      medias_count: 3
    },
    app_id: 10866,
    title: "我们玩的是一个游戏吗？",
    content: "",
    content_desc: "推友 ヤナマリ 以自己为例，推荐了《健身环大冒险》两个塑造腰部曲线的运动：高举双臂侧弯 和 俯身划船。她曾通过低碳水饮食配合《健身环大冒险》和《Fitness Boxing》，一年内减重 30 KG！",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=6049ece98e9f09363c577d75",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "6049ece98e9f09363c577d75"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=6049ece98e9f09363c577d75"
  }, {
    pk: "6049ea92b15ec00a4d755349",
    summary: "@果壳：除了咖啡之外，你日常吃的面粉、巧克力、罐头、橙汁等各种食物里，都可能有虫子、蝇卵、老鼠毛……只是你不知道而已。（理论上它们没有损害你的身体健康。不过等你看完这条微博，或许精神健康会受到损害）",
    agree_counts: 4,
    comment_counts: 9,
    date: 1615456719,
    type: "a",
    item_type: "f_1",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "8496阅读",
    show_info: {
      show_type: "1_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049ea92b15ec00a4d75534a_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049ea92b15ec00a4d75534a_640.jpg",
        w: "1000",
        h: "667"
      }],
      medias_count: 1
    },
    app_id: 10866,
    title: "不干不净 吃了没病",
    content: "",
    content_desc: "@果壳：除了咖啡之外，你日常吃的面粉、巧克力、罐头、橙汁等各种食物里，都可能有虫子、蝇卵、老鼠毛……只是你不知道而已。（理论上它们没有损害你的身体健康。不过等你看完这条微博，或许精神健康会受到损害）",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=6049ea92b15ec00a4d755349",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "6049ea92b15ec00a4d755349"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=6049ea92b15ec00a4d755349"
  }, {
    pk: "6049e95a8e9f0907f20a6e25",
    summary: "",
    agree_counts: 3,
    comment_counts: 5,
    date: 1615456422,
    type: "a",
    item_type: "f_1",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "1.24万阅读",
    show_info: {
      show_type: "1_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e95a8e9f0907f20a6e26_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e95a8e9f0907f20a6e26_640.jpg",
        w: "828",
        h: "817"
      }],
      medias_count: 1
    },
    app_id: 10866,
    title: "有被敷衍到 ​​​​",
    content: "",
    content_desc: "",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=6049e95a8e9f0907f20a6e25",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "6049e95a8e9f0907f20a6e25"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=6049e95a8e9f0907f20a6e25"
  }, {
    pk: "6049e5fc8e9f0956d13dc27d",
    summary: "",
    agree_counts: 0,
    comment_counts: 1,
    date: 1615455691,
    type: "a",
    item_type: "f_1",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "2.08万阅读",
    show_info: {
      show_type: "1_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e5fc8e9f0956d13dc27e_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e5fc8e9f0956d13dc27e_640.jpg",
        w: "690",
        h: "950"
      }],
      medias_count: 1
    },
    app_id: 10866,
    title: "一只在副驾驶长居的狗狗",
    content: "",
    content_desc: "",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=6049e5fc8e9f0956d13dc27d",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "6049e5fc8e9f0956d13dc27d"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=6049e5fc8e9f0956d13dc27d"
  }, {
    pk: "6049e5fc8e9f0956473bcba3",
    summary: "",
    agree_counts: 1,
    comment_counts: 2,
    date: 1615455476,
    type: "a",
    item_type: "f_1",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "1.12万阅读",
    show_info: {
      show_type: "1_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e5fc8e9f0956473bcba5_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e5fc8e9f0956473bcba5_640.jpg",
        w: "690",
        h: "365"
      }],
      medias_count: 1
    },
    app_id: 10866,
    title: "遇到一位好老师有多幸运",
    content: "",
    content_desc: "",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=6049e5fc8e9f0956473bcba3",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "6049e5fc8e9f0956473bcba3"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=6049e5fc8e9f0956473bcba3"
  }, {
    pk: "6049e3ad8e9f0956be7d3a7f",
    summary: "今天聊点儿高端、深刻的东西，艺术！\n顺便揭露一些 “丧尽天良” 的社会乱象 ——\n美国艺术家 Ellsworth Kelly 的名画《绿斑》，2019 年卖出 160 万美元；\n同样出自 Kelly 之手的《绿白》，卖出 330 万美元；",
    agree_counts: 11,
    comment_counts: 7,
    date: 1615455126,
    type: "a",
    item_type: "f_9",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "1128阅读",
    show_info: {
      show_type: "30_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a82_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a82_640.jpg",
        w: "593",
        h: "437"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a86_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a86_640.jpg",
        w: "1080",
        h: "1620"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a87_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a87_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a88_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a88_640.jpg",
        w: "1080",
        h: "654"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a89_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a89_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a8a_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a8a_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a8b_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a8b_640.jpg",
        w: "736",
        h: "322"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a8c_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a8c_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a8d_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a8d_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a8f_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a8f_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a90_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a90_640.jpg",
        w: "1080",
        h: "608"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a91_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a91_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a93_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a93_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a94_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a94_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a95_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a95_640.jpg",
        w: "1080",
        h: "654"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a96_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a96_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a97_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a97_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a98_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a98_640.jpg",
        w: "1080",
        h: "654"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a99_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a99_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a9a_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a9a_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a9b_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a9b_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a9c_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a9c_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a9e_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a9e_640.jpg",
        w: "1080",
        h: "656"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a9f_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3a9f_640.jpg",
        w: "1080",
        h: "699"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3aa0_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3aa0_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3aa1_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3aa1_640.jpg",
        w: "1080",
        h: "607"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3aa2_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3aa2_640.jpg",
        w: "1080",
        h: "657"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3aa3_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3aa3_640.jpg",
        w: "1080",
        h: "651"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3aa4_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3aa4_640.jpg",
        w: "1080",
        h: "743"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3aa5_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ad8e9f0956be7d3aa5_640.jpg",
        w: "500",
        h: "356"
      }],
      medias_count: 30
    },
    app_id: 10866,
    title: "多名美国顶级富豪被神秘中国画家疯狂割韭菜，引起极度舒适！",
    content: "",
    content_desc: "今天聊点儿高端、深刻的东西，艺术！顺便揭露一些 “丧尽天良” 的社会乱象 ——美国艺术家 Ellsworth Kelly 的名画《绿斑》，2019 年卖出 160 万美元；同样出自 Kelly 之手的《绿白》，卖出 330 万美元；",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=6049e3ad8e9f0956be7d3a7f",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "6049e3ad8e9f0956be7d3a7f"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=6049e3ad8e9f0956be7d3a7f"
  }, {
    pk: "6049e3ae8e9f0956fc328afb",
    summary: "网上很多说话不客气的往往属于没经历过事的，自己经历过之后才能知道世事的酸甜苦辣，对别人才能宽容理解\n",
    agree_counts: 1,
    comment_counts: 4,
    date: 1615455090,
    type: "a",
    item_type: "f_1",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "4068阅读",
    show_info: {
      show_type: "1_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ae8e9f0956fc328b04_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ae8e9f0956fc328b04_640.jpg",
        w: "640",
        h: "640"
      }],
      medias_count: 1
    },
    app_id: 10866,
    title: "被社会毒打一顿就知道世事的酸甜苦辣",
    content: "",
    content_desc: "网上很多说话不客气的往往属于没经历过事的，自己经历过之后才能知道世事的酸甜苦辣，对别人才能宽容理解",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=6049e3ae8e9f0956fc328afb",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "6049e3ae8e9f0956fc328afb"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=6049e3ae8e9f0956fc328afb"
  }, {
    pk: "6049e3ae8e9f0956d27debb4",
    summary: "@汪有：收到女青年私信：\n说爸妈在一线城市就一套房，估计要给自己弟弟，问我咋办。\n这题对我一个独生子女而言超纲了。\n挂我这种号解决不了，得转诊到大医院，比如黄执中学长那边挂专家号才行。\n我只能硬答一个。",
    agree_counts: 0,
    comment_counts: 7,
    date: 1615454979,
    type: "a",
    item_type: "f_1",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "2.22万阅读",
    show_info: {
      show_type: "1_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ae8e9f0956d27debb5_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ae8e9f0956d27debb5_640.jpg",
        w: "690",
        h: "460"
      }],
      medias_count: 1
    },
    app_id: 10866,
    title: "爸妈在一线城市就一套房，估计要给自己弟弟，问我咋办",
    content: "",
    content_desc: "@汪有：收到女青年私信：说爸妈在一线城市就一套房，估计要给自己弟弟，问我咋办。这题对我一个独生子女而言超纲了。挂我这种号解决不了，得转诊到大医院，比如黄执中学长那边挂专家号才行。我只能硬答一个。",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=6049e3ae8e9f0956d27debb4",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "6049e3ae8e9f0956d27debb4"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=6049e3ae8e9f0956d27debb4"
  }, {
    pk: "6049e3ae8e9f09573941e20d",
    summary: "",
    agree_counts: 0,
    comment_counts: 1,
    date: 1615454958,
    type: "a",
    item_type: "f_9",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "1.13万阅读",
    show_info: {
      show_type: "8_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e20e_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e20e_640.jpg",
        w: "690",
        h: "503"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e20f_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e20f_640.jpg",
        w: "690",
        h: "475"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e210_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e210_640.jpg",
        w: "690",
        h: "459"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e211_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e211_640.jpg",
        w: "690",
        h: "415"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e212_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e212_640.jpg",
        w: "690",
        h: "524"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e214_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e214_640.jpg",
        w: "690",
        h: "417"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e215_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e215_640.jpg",
        w: "690",
        h: "468"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e216_640.jpg",
        src: "http://zkres.myzaker.com/202103/6049e3ae8e9f09573941e216_640.jpg",
        w: "690",
        h: "472"
      }],
      medias_count: 8
    },
    app_id: 10866,
    title: "Audun Rikardsen 照相机实用技术",
    content: "",
    content_desc: "",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=6049e3ae8e9f09573941e20d",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "6049e3ae8e9f09573941e20d"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=6049e3ae8e9f09573941e20d"
  }, {
    pk: "604890258e9f092da8063844",
    summary: "",
    agree_counts: 13,
    comment_counts: 14,
    date: 1615368037,
    type: "a",
    item_type: "f_1",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "1.94万阅读",
    show_info: {
      show_type: "1_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/604890258e9f092da8063846_640.jpg",
        src: "http://zkres.myzaker.com/202103/604890258e9f092da8063846_640.jpg",
        w: "630",
        h: "349"
      }],
      medias_count: 1
    },
    app_id: 10866,
    title: "我建议通过他的建议",
    content: "",
    content_desc: "",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=604890258e9f092da8063844",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "604890258e9f092da8063844"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=604890258e9f092da8063844"
  }, {
    pk: "60488f0a8e9f092dbc71b6ba",
    summary: "英国保健署（NHS）医生Karan Raj透露，多数咖啡粉里都会有蟑螂，因为这些蟑螂无法被彻底处理掉，只能和咖啡豆一起被烘烤、磨碎。但蟑螂蛋白质含量很高，对人体没有什么危害，只是对蟑螂过敏体质者要注意。许多英国网友回复：你特么毁了我的生活，我再也不敢喝咖啡了！我并不想知道这么多",
    agree_counts: 12,
    comment_counts: 13,
    date: 1615367900,
    type: "a",
    item_type: "f_1",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "1.54万阅读",
    show_info: {
      show_type: "1_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/60488f0a8e9f092dbc71b6bb_640.jpg",
        src: "http://zkres.myzaker.com/202103/60488f0a8e9f092dbc71b6bb_640.jpg",
        w: "600",
        h: "310"
      }],
      medias_count: 1
    },
    app_id: 10866,
    title: "我再也无法直视巧克力和咖啡了...... ​​​​",
    content: "",
    content_desc: "英国保健署（NHS）医生Karan Raj透露，多数咖啡粉里都会有蟑螂，因为这些蟑螂无法被彻底处理掉，只能和咖啡豆一起被烘烤、磨碎。但蟑螂蛋白质含量很高，对人体没有什么危害，只是对蟑螂过敏体质者要注意。许多英国网友回复：你特么毁了我的生活，我再也不敢喝咖啡了！我并不想知道这么多",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=60488f0a8e9f092dbc71b6ba",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "60488f0a8e9f092dbc71b6ba"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=60488f0a8e9f092dbc71b6ba"
  }, {
    pk: "60488dc98e9f09796227753f",
    summary: "",
    agree_counts: 6,
    comment_counts: 4,
    date: 1615367492,
    type: "a",
    item_type: "f_1",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "2.64万阅读",
    show_info: {
      show_type: "1_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/60488dc98e9f097962277540_640.jpg",
        src: "http://zkres.myzaker.com/202103/60488dc98e9f097962277540_640.jpg",
        w: "1024",
        h: "1285"
      }],
      medias_count: 1
    },
    app_id: 10866,
    title: "白幻视去向",
    content: "",
    content_desc: "",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=60488dc98e9f09796227753f",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "60488dc98e9f09796227753f"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=60488dc98e9f09796227753f"
  }, {
    pk: "604888308e9f094c210369ad",
    summary: "蓄力？畜力？（@AlynxZhou）\n",
    agree_counts: 5,
    comment_counts: 7,
    date: 1615366003,
    type: "a",
    item_type: "f_1",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "1.77万阅读",
    show_info: {
      show_type: "1_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/604888308e9f094c210369ae_640.jpg",
        src: "http://zkres.myzaker.com/202103/604888308e9f094c210369ae_640.jpg",
        w: "840",
        h: "659"
      }],
      medias_count: 1
    },
    app_id: 10866,
    title: "蓄力？畜力？",
    content: "",
    content_desc: "蓄力？畜力？（@AlynxZhou）",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=604888308e9f094c210369ad",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "604888308e9f094c210369ad"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=604888308e9f094c210369ad"
  }, {
    pk: "604885d78e9f094e4e76e762",
    summary: "",
    agree_counts: 2,
    comment_counts: 1,
    date: 1615365355,
    type: "a",
    item_type: "f_9",
    author_info: {
      logo: {
        type: "2",
        url: "https://mp-video.myzaker.com/image/201906/5cf893397c274f0f55021243.jpg?x-oss-process=image/resize,w_320",
        bg_color: "#666666",
        border: "#000000",
        hasLog: "1"
      },
      name: "",
      uid: "",
      pull_black_name: "涨姿势",
      media_custom_logo: {
        url: "https://mp-video.myzaker.com/image/201907/5d31c8667c274f211e5a390a.png",
        w: "98",
        h: "54"
      }
    },
    video_info: [],
    is_myself: "N",
    is_stick: "N",
    more_select: {
      is_can_shield: "N"
    },
    post_tag: [],
    is_can_shield: "N",
    view_num: "2.06万阅读",
    show_info: {
      show_type: "4_s",
      medias_list: [{
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/604885d78e9f094e4e76e763_640.jpg",
        src: "http://zkres.myzaker.com/202103/604885d78e9f094e4e76e763_640.jpg",
        w: "1024",
        h: "753"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/604885d78e9f094e4e76e764_640.jpg",
        src: "http://zkres.myzaker.com/202103/604885d78e9f094e4e76e764_640.jpg",
        w: "440",
        h: "293"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/604885d78e9f094e4e76e765_640.jpg",
        src: "http://zkres.myzaker.com/202103/604885d78e9f094e4e76e765_640.jpg",
        w: "440",
        h: "397"
      }, {
        type: "image",
        min_src: "http://zkres.myzaker.com/202103/604885d78e9f094e4e76e766_640.jpg",
        src: "http://zkres.myzaker.com/202103/604885d78e9f094e4e76e766_640.jpg",
        w: "440",
        h: "440"
      }],
      medias_count: 4
    },
    app_id: 10866,
    title: "今天你绿了吗？？",
    content: "",
    content_desc: "",
    auther_name: "涨姿势",
    weburl: "https://iphone.myzaker.com/l.php?l=604885d78e9f094e4e76e762",
    comment_type: 0,
    author_open_info: {
      type: "block",
      open_info: {
        author_app_id: "10866",
        app_id: "10866_946",
        author: "涨姿势"
      }
    },
    open_info: {
      open_type: "article",
      open_id: "604885d78e9f094e4e76e762"
    },
    detail_link: "//rongmeiti.dev58.myzaker.com/article_detail?article_pk=604885d78e9f094e4e76e762"
  }],
  article_info: {
    media: [{
      type: "image",
      id: "603054c162276816a1000031",
      url: "http://zkres2.myzaker.com/202102/603054c162276816a1000031_1024.jpg",
      m_url: "http://zkres2.myzaker.com/202102/603054c162276816a1000031_640.jpg",
      min_url: "http://zkres.myzaker.com/202102/603054c162276816a1000031_320.jpg",
      raw_url: "https://images.shobserver.com/news/690_390/2021/2/20/f0465e35a14b4a018db0d95e2e8563e8.jpg",
      w: "690",
      h: "390",
      similar_stat: "2"
    }, {
      type: "image",
      id: "603054c162276816a1000032",
      url: "http://zkres1.myzaker.com/202102/603054c162276816a1000032_1024.jpg",
      m_url: "http://zkres1.myzaker.com/202102/603054c162276816a1000032_640.jpg",
      min_url: "http://zkres.myzaker.com/202102/603054c162276816a1000032_320.jpg",
      raw_url: "https://images.shobserver.com/export_img/2021/2/20/86963718d48445afb858b0f3ecd3d0bb.jpg",
      w: "600",
      h: "385",
      similar_stat: "1",
      face_data: {
        left_top_point: {
          x: "0.56",
          y: "0.30"
        },
        right_bottom_point: {
          x: "0.61",
          y: "0.39"
        }
      }
    }, {
      type: "image",
      id: "603054c162276816a1000033",
      url: "http://zkres1.myzaker.com/202102/603054c162276816a1000033_1024.jpg",
      m_url: "http://zkres1.myzaker.com/202102/603054c162276816a1000033_640.jpg",
      min_url: "http://zkres.myzaker.com/202102/603054c162276816a1000033_320.jpg",
      raw_url: "https://images.shobserver.com/export_img/2021/2/20/d2bd1302bd2a4c09b755633eb268076b.jpg",
      w: "600",
      h: "506",
      similar_stat: "2",
      face_data: {
        left_top_point: {
          x: "0.33",
          y: "0.21"
        },
        right_bottom_point: {
          x: "0.53",
          y: "0.44"
        }
      }
    }, {
      type: "image",
      id: "603054c162276816a1000034",
      url: "http://zkres1.myzaker.com/202102/603054c162276816a1000034_1024.jpg",
      m_url: "http://zkres1.myzaker.com/202102/603054c162276816a1000034_640.jpg",
      min_url: "http://zkres.myzaker.com/202102/603054c162276816a1000034_320.jpg",
      raw_url: "https://images.shobserver.com/export_img/2021/2/20/7b04739b-65c9-4d91-b2fa-67600e2e7626.jpg",
      w: "576",
      h: "432",
      similar_stat: "1",
      face_data: {
        left_top_point: {
          x: "0.42",
          y: "0.33"
        },
        right_bottom_point: {
          x: "0.50",
          y: "0.44"
        }
      }
    }, {
      type: "image",
      id: "603054c162276816a1000035",
      url: "http://zkres2.myzaker.com/202102/603054c162276816a1000035_1024.jpg",
      m_url: "http://zkres2.myzaker.com/202102/603054c162276816a1000035_640.jpg",
      min_url: "http://zkres.myzaker.com/202102/603054c162276816a1000035_320.jpg",
      raw_url: "https://images.shobserver.com/export_img/2021/2/20/20dd5961105f42b7a253d9c9c9d572c8.jpg",
      w: "600",
      h: "450",
      similar_stat: "1"
    }],
    pk: "60305524b15ec06b526188c3",
    is_ad: null,
    app_id: "14437",
    app_name: "上观新闻",
    title: "从相“加”到相“融”  习近平绘就媒体融合发展蓝图",
    author: "上观新闻",
    url: "https://export.shobserver.com/zaker/html/342953.html",
    content: '<style>body{line-height:1.5em; margin:0; word-wrap: break-word; word-break:break-word; } img{max-width:100%;} .img_box{width:100%; min-height:100px; text-align:center; margin-bottom:5px;}.img_box img{vertical-align: middle;}#content{margin:0 0.8em;}p{padding:0px; margin:0.6em 0}a{color: #000;text-decoration : underline;}</style><div id="content"><p><div class="img_box" id="id_imagebox_0" onclick=\'\'><div class="content_img_div perview_img_div"><img class="lazy opacity_0 " id="img_0" data-original="http://zkres2.myzaker.com/202102/603054c162276816a1000031_1024.jpg"  data-height=\'390\' data-width=\'690\' /></div></div>　　2月19日，对全国新闻工作者而言是一个有着特殊意义的日子。</p><p>　　5年前的2月19日，习近平总书记在北京主持召开党的新闻舆论工作座谈会，并到人民日报社、新华社、中央电视台3家中央新闻单位调研。</p><p>　　总书记提出，尽快从相"加"阶段迈向相"融"阶段，从"你是你、我是我"变成"你中有我、我中有你"，进而变成"你就是我、我就是你"，着力打造一批新型主流媒体。</p><p>　　"融合发展关键在融为一体、合而为一。"党的十八大以来，以习近平同志为核心的党中央高度重视传统媒体和新兴媒体的融合发展，促进推动媒体融合向纵深发展，为媒体融合发展绘就路线图，引领新闻舆论工作气象一新。</p><p>　　移动优先 强化互联网思维</p><p>　　"党的新闻舆论工作是党的一项重要工作，是治国理政、定国安邦的大事。"</p><p>　　"宣传思想工作一定要把围绕中心、服务大局作为基本职责，胸怀大局、把握大势、着眼大事，找准工作切入点和着力点，做到因势而谋、应势而动、顺势而为。"</p><p>　　所当乘者势也，不可失者时也。</p><p>　　在习近平总书记眼中，互联网的蓬勃发展就是"大势"之一。随着舆论环境、媒体格局、传播方式发生深刻变化，总书记于2016年2月19日来到3家中央新闻单位听取汇报、试用体验，对互联网催生的新闻传播新技术、新业态、新机制进行调研。</p><p>　　在人民日报社，总书记走进新媒体中心，在一台电脑前坐下，点击键盘，通过"两微一端"向全国人民致以元宵节问候。</p><p>　　在新华社，总书记点击手机屏幕，通过新华社客户端为全国新闻工作者点赞；拿起手持视频直播云终端，对着随行人员试拍，体验记者的工作状态；通过全媒报道平台远程指挥系统同正在河南兰考县采访的新华社记者连线……</p><p><div class="img_box" id="id_imagebox_1" onclick=\'\'><div class="content_img_div perview_img_div"><img class="lazy opacity_0 " id="img_1" data-original="http://zkres1.myzaker.com/202102/603054c162276816a1000032_1024.jpg"  data-height=\'385\' data-width=\'600\' /></div></div>　　2016年2月19日，习近平总书记在北京主持召开党的新闻舆论工作座谈会，并到中央新闻单位调研。这是总书记在中央电视台总控中心同工作人员亲切握手。</p><p>　　在中央电视台，总书记听取中央电视台板块业务、媒体融合等情况介绍，并在《新闻联播》演播室亲自切换按钮体验模拟播出。</p><p>　　互联网已成为新闻竞争的主战场，也是党的舆论工作的重要阵地。</p><p>　　总书记与新媒体的"亲密接触"，对"互联网思维"的细致调研，不仅体现了党中央对传统媒体和新兴媒体融合发展的高度关注，也是对媒体融合向纵深发展的有力推动。</p><p>　　守正创新 构建全媒体格局</p><p>　　当今世界正面临着百年未有之大变局，同样引发全球国际传播格局不断变革。先进的思想若无先进的传播手段支撑，很难深入人心；正确的主张若没有快速多样的先进技术传播，便无法有效占领舆论阵地。</p><p>　　针对媒体传播格局变化带来的挑战，总书记指出，随着形势发展，党的新闻舆论工作必须创新理念、内容、体裁、形式、方法、手段、业态、体制、机制，增强针对性和实效性。要适应分众化、差异化传播趋势，加快构建舆论引导新格局。</p><p>　　早在2014年8月召开的中央全面深化改革领导小组第四次会议上，总书记就提出了以"先进技术为支撑、内容建设为根本"，推动传统媒体和新兴媒体深度融合的创新发展思路。</p><p><div class="img_box" id="id_imagebox_2" onclick=\'\'><div class="content_img_div perview_img_div"><img class="lazy opacity_0 " id="img_2" data-original="http://zkres1.myzaker.com/202102/603054c162276816a1000033_1024.jpg"  data-height=\'506\' data-width=\'600\' /></div></div>　　2018年8月21日至22日，全国宣传思想工作会议在北京召开。习近平总书记出席会议并发表重要讲话。</p><p>　　2018年8月21日，习近平总书记在全国宣传思想工作会议上强调，要加强传播手段和话语方式创新，让党的创新理论"飞入寻常百姓家"。要扎实抓好县级融媒体中心建设，更好引导群众、服务群众。</p><p>　　谆谆话语，殷殷寄望。</p><p>　　"读者在哪里，受众在哪里，宣传报道的触角就要伸向哪里，宣传思想工作的着力点和落脚点就要放在哪里。要顺应互联网发展大势，勇于创新、勇于变革，利用互联网特点和优势，推进理念、内容、手段、体制机制等全方位创新。"</p><p>　　5年来，从主题宣传到重大战役，从典型宣传到突发事件，各大媒体把新闻现场变为融合报道的竞技场，亮绝活、出奇招，以全新理念完善顶层设计，以技术进步拓宽报道途径，以内容创新赢得发展优势，报网端微百花齐放，文图音视争奇斗艳，无人机航拍、VR/AR技术、人工智能等"十八般兵器"一齐上阵、竞相发力，向深度融合、全面转型、一体化发展的方向加速推进。</p><p>　　以融合发展为突破口，各大新闻媒体创新方法手段，适应受众需求，把握时度效，推进网上网下不同平台优势叠加互补，一个拥有强大传播力、公信力、影响力的新型主流新闻媒体矩阵正在时代变革中"破茧而出"。</p><p>　　得人者兴 推进人才队伍融通</p><p>　　媒体竞争关键是人才竞争，媒体优势核心是人才优势。</p><p>　　全媒体时代，如何培养一支优秀的新闻工作者队伍是习近平总书记高度重视的大问题。</p><p><div class="img_box" id="id_imagebox_3" onclick=\'\'><div class="content_img_div perview_img_div"><img class="lazy opacity_0 " id="img_3" data-original="http://zkres1.myzaker.com/202102/603054c162276816a1000034_1024.jpg"  data-height=\'432\' data-width=\'576\' /></div></div>　　2020年1月24日，除夕当天，中央广播电视总台驰援武汉报道小分队出发。</p><p>　　"要加快培养造就一支政治坚定、业务精湛、作风优良、党和人民放心的新闻舆论工作队伍。"</p><p>　　"要提高业务能力，勤学习、多锻炼，努力成为全媒型、专家型人才。"</p><p>　　"要转作风改文风，俯下身、沉下心，察实情、说实话、动真情，努力推出有思想、有温度、有品质的作品。"</p><p>　　……</p><p>　　在路上，心中才有时代；</p><p>　　在基层，心中才有群众；</p><p>　　在现场，心中才有感动。</p><p>　　谆谆寄语，鼓舞新闻工作者奋勇前行。</p><p><div class="img_box" id="id_imagebox_4" onclick=\'\'><div class="content_img_div perview_img_div"><img class="lazy opacity_0 " id="img_4" data-original="http://zkres2.myzaker.com/202102/603054c162276816a1000035_1024.jpg"  data-height=\'450\' data-width=\'600\' /></div></div>　　2020年3月10日，中央广播电视总台央视频记者张璇（右）在武汉武昌方舱医院做休舱直播采访。</p><p>　　纪念红军长征胜利80周年之际，他们背起行囊，沿着红军的足迹，感受长征的伟大与艰辛；抗击新冠肺炎疫情期间，他们深入武汉抗疫前线，逆行出征，挖掘全民战"疫"中涌现的感人故事；春运期间，他们把镜头对准亿万返乡农民工，关注最真实的基层群众……</p><p>　　"浩渺行无极，扬帆但信风。"今天的中国，比历史上任何时期都更接近中华民族伟大复兴的目标，比历史上任何时期都更有信心、更有能力实现这个目标。今日的广大新闻舆论工作者，以总书记"2·19"重要讲话精神为指引和遵循，争做党的政策主张的传播者、时代风云的记录者、社会进步的推动者、公平正义的守望者，与时代共振，与人民同心，一路砥砺前行。</p><p>　　（中央广播电视总台央视网）</p><p>　　栏目主编：秦红 顾万全 张武 本文作者：央视网 文字编辑：宋彦霖</p></div>',
    a_type: null,
    article_tag: ["总书记", "互联网", "习近平总书记", "中央电视台", "新华社"],
    new_tag: ["习近平", "蓝图", "融合", "媒体", "春运", "方舱", "信风", "专家型", "媒体传播", "推动者", "传播者", "主战场", "实效性", "着力点", "新机制", "百姓家", "总台", "小分队", "公信力", "落脚点"],
    addtime: "1613779977",
    tag: "习近平,总书记",
    new_app_id: 36,
    rgcms_pushInfo: null,
    video_type: false,
    share_img: "",
    back_source: null,
    is_original: 0,
    simhash_content: "EC1E98852C07785B",
    stat: 1,
    content_format: "html",
    block_color: "#c52026",
    time: "02-20",
    thumbnail_pic: "http://zkres1.myzaker.com/202102/603054c162276816a1000032_1024.jpg",
    thumbnail_mpic: "http://zkres1.myzaker.com/202102/603054c162276816a1000032_640.jpg",
    thumbnail_picsize: "600,385"
  },
  contact: "/contact.html",
  ecology: "/ecology.html",
  integrated: "/integrated.html",
  dispatch: "/dispatch.html",
  launch: "/launch.html",
  integrated_services: "/integrated-services.html",
  security: "/security.html"
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Banner",
  props: {
    height: {
      type: Number | String,
      default: 560
    },

    type: {
      type: String,
      default: 'image'
    },

    url: {
      type: String
    }
  },
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ })

},[161]);


// WEBPACK FOOTER //
// static/js/about.js?bebaaeb61462a8896ec3